//main
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function calculateExtraDiscount(originalPrice, desiredDiscountedPrice, initialDiscountPercentage) {
  const totalDiscountNeeded = ((originalPrice - desiredDiscountedPrice) / originalPrice) * 100;
  const extraDiscountNeeded = totalDiscountNeeded - initialDiscountPercentage;
  return parseFloat(extraDiscountNeeded) > 0 ? parseFloat(extraDiscountNeeded).toFixed(4): 0;
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// Custom MottAndBow Created function formatMoneyAmmount
// This function is used to format the price amount in the format of the currency
// 
Shopify.formatMoneyAmmount = function(number) {
  
  const formatReference = document.querySelector("#price-format-guide");

  if (!formatReference) {
    throw new Error("Missing price format guide element (#price-format-guide).");
  }

  const formatExample = formatReference.textContent.trim();
  let usesCommas = formatExample.indexOf(",") < formatExample.indexOf("."); // Check if commas come before periods

  // Stricter input validation with type check and NaN check
  if (typeof number !== "number" || isNaN(number)) {
    throw new TypeError("Input must be a valid number.");
  }

  // Formatting logic
  let formattedAmount = number;

  // Ensure 'number' is parsed as a float to prevent formatting issues
  let parsedNumber = parseFloat(number);
  //debugger;
  console.log(Math.floor(number).toString());
  console.log(number.toString());
  
  if (  Math.floor(number).toString() != number.toString() ) {
   
    formattedAmount = parsedNumber.toFixed(2);
  }
  
  if (usesCommas) {
    // Commas for thousands, periods for decimals

    // Use Intl.NumberFormat to format numbers with commas for thousands and points for decimals
    const formatter = new Intl.NumberFormat('en-US');
    formattedAmount = formatter.format(formattedAmount);
    if (formattedAmount.toString().split('.').length > 1) {
      if (formattedAmount.toString().split('.')[1].length == 1) {
        formattedAmount = formattedAmount + '0';
      }
    }
  } else {



    // Use Intl.NumberFormat to format numbers with periods for thousands and commas for decimals
    const formatter = new Intl.NumberFormat('de-DE'); // 'de-DE' uses the format you're looking for

    
    formattedAmount = formatter.format(formattedAmount);

    if (formattedAmount.toString().split(',').length > 1) {
      if (formattedAmount.toString().split(',')[1].length == 1) {
        formattedAmount = formattedAmount + '0';
      }
    }
    
  }
  return formattedAmount; 
}
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
    this.querySelectorAll(".disclosure__list li a").forEach((item) =>
      item.addEventListener("click", this.onClickLocalization.bind(this))
    );
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      // element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      if (element.nextElementSibling)
        element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      // this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      //   details.removeAttribute('open');
      //   details.classList.remove('menu-opening');
      // });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onClickLocalization(event) {
    event.preventDefault();
    const form = event.currentTarget.closest("form");
    console.log(form);
    if (!form) return;
    form.querySelector(
      'input[name="language_code"], input[name="country_code"]'
    ).value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}



customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class MobileNavbar extends MenuDrawer {
  constructor() {
    super();

    this.mainSummary = this.querySelector("summary.header__icon--menu");
    this.mainSummary.addEventListener("click", this.onOverlayClick.bind(this));
    this.closeBtn = this.querySelector(".close_nav_btn");
    this.closeBtn.addEventListener("click", this.onCloseClick.bind(this));

    this.switchBtns = this.querySelectorAll(
      ".navigation_toggle-container .switch--btn"
    );
    this.switchInit();

    this.darkOverlay = this.querySelector(".dark-overlay");
    this.darkOverlay.addEventListener("click", this.onOverlayClick.bind(this));
  }

  switchInit() {
    this.switchBtns.forEach((switchBtn) => {
      switchBtn.addEventListener("click", this.onSwitchClick.bind(this));
    });

    const activeSwitchBtn = this.querySelectorAll(
      ".navigation_toggle-container .switch--btn.switch-active"
    );
    const activeSwitchDrawers = this.querySelectorAll(
      ".switch-menu-drawer.switch-active"
    );

    if (
      this.switchBtns &&
      this.switchBtns.length > 0 &&
      (!activeSwitchBtn || activeSwitchBtn.length <= 0)
    ) {
      // Cancelable so onSwitchClick's preventDefault() stops the <a href="#">
      // from navigating to "#", which wiped hashes like #rivo on page load
      const evt = new Event("click", { cancelable: true });
      this.switchBtns[0].dispatchEvent(evt);
    }
    // more than 1 switch buttons are active due to overlapping childmenu elements
    else if (activeSwitchBtn.length > 1) {
      const prevMenuClicked = localStorage.getItem("mobmenu");
      // turn off all the active buttons if it does not match the previous clicked attribute
      activeSwitchBtn.forEach((btn, index) => {
        if (prevMenuClicked) {
          btn.id !== `toggle-${prevMenuClicked}`
            ? btn.classList.remove("switch-active")
            : "";
        } else {
          index === 0 ? "" : btn.classList.remove("switch-active");
        }
      });
      // do the same for drawers
      activeSwitchDrawers.forEach((drawer, index) => {
        if (prevMenuClicked) {
          drawer.id !== `drawer-${prevMenuClicked}`
            ? drawer.classList.remove("switch-active")
            : "";
        } else {
          index === 0 ? "" : drawer.classList.remove("switch-active");
        }
      });
    }
  }

  onSwitchClick(event) {
    event.preventDefault();
    const currentBtn = event.target;
    const currentId = currentBtn.id;
    // save the clicked menu as "previous element clicked"
    // This value will be used when there are move than 1 active switch buttons due to overlapping child menus
    localStorage.setItem("mobmenu", currentId.split("toggle-")[1]);
    const menuToToggle = this.querySelector(`ul[data-link-id="${currentId}"]`);

    const activeBtn = currentBtn.parentElement.querySelector(".switch-active");
    const activeMenu = currentBtn
      .closest(".menu-drawer__navigation")
      .querySelector("ul.switch-active");

    if (activeBtn && activeBtn != currentBtn) {
      activeBtn.classList.remove("switch-active");
      currentBtn.classList.add("switch-active");
    } else {
      currentBtn.classList.add("switch-active");
    }

    if (activeMenu && activeMenu != menuToToggle) {
      activeMenu.classList.remove("switch-active");
      menuToToggle.classList.add("switch-active");
    } else {
      menuToToggle.classList.add("switch-active");
    }
  }

  onCloseClick(event) {
    const mainSummary = this.mainSummary;
    const mainDetail = this.mainDetailsToggle;
    this.darkOverlay.classList.remove("active");

    this.closeMenuDrawer(mainSummary);
  }

  onOverlayClick(event) {
    const mainSummary = this.mainSummary;
    const mainDetail = this.mainDetailsToggle;
    const isOpen = mainDetail.hasAttribute("open");
    this.darkOverlay.classList.toggle("active");

    if (isOpen) event.preventDefault();
    isOpen
      ? this.closeMenuDrawer(mainSummary)
      : this.openMenuDrawer(mainSummary);
  }
}

customElements.define("mobile-navbar", MobileNavbar);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector(".template-popup")?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    // property for sliding action
    // this.moved = false;

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    // desktop sliding action
    // this.slider.addEventListener("mousedown", this.downListener.bind(this));
    // this.slider.addEventListener("mousemove", this.moveListener.bind(this));

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.relatedList = window.theme.related_prod_handles;
    this.relatedInventoryStatus = [];
    // Preorder
    this.preorderMessage = document.querySelector(
      ".product-form .preorder-text"
    );
    // Pre-Order product data
    this.preOrderProduct = null;
    this.preOrderProductData = null;
    this.preOrderHandle = window.theme?.pre_order_handle || null;
    this.enablePreOrder = window.theme?.enable_pre_order || false;
    this.enablePreOrderNonUSA = window.theme?.enable_pre_order_non_usa || false;
    this.countryCode = window.theme?.country_code || null;
    // Flag to indicate if pre-order is available for current variant
    this.hasPreOrderAvailableFlag = false;

    this.init();
    this.multiBundle = document.querySelector('multi-bundle');
  }

  init() {
    this.relatedList.forEach((rel_prod) => {
      fetch(`${Shopify.routes.root}products/${rel_prod}?view=inventory_status`)
        .then((response) => response.json())
        .then((data) => {
          this.relatedInventoryStatus.push(data);

        });
    });
    
    // Load Pre-Order product if handle exists
    if (this.preOrderHandle) {
      this.loadPreOrderProduct();
    }
  }

  async loadPreOrderProduct() {
    if (!this.preOrderHandle) return;
    
    try {
      const response = await fetch(`${Shopify.routes.root}products/${this.preOrderHandle}?view=inventory_status`);
      if (response.ok) {
        const data = await response.json();
        this.preOrderProductData = data;
        
        // Also fetch full product data for variants
        const fullProductResponse = await fetch(`${Shopify.routes.root}products/${this.preOrderHandle}.js`);
        if (fullProductResponse.ok) {
          this.preOrderProduct = await fullProductResponse.json();
          // Extract the generic pre-order date from the pre-order product tags
          // (fallback when variant-specific arrival_date is not set). This keeps
          // window.theme.pre_order_date in sync when switching fits in 'preo' mode.
          if (this.preOrderProduct && Array.isArray(this.preOrderProduct.tags)) {
            const dateTag = this.preOrderProduct.tags.find(t => typeof t === 'string' && t.indexOf('enable_pre-order_') === 0);
            if (dateTag) {
              window.theme.pre_order_date = dateTag.split('enable_pre-order_')[1] || null;
            }
          }
          // Fetch variant-specific arrival dates (custom.arrival_date metafield)
          try {
            const datesRes = await fetch(`${Shopify.routes.root}products/${this.preOrderHandle}?view=preorder-dates`);
            if (datesRes.ok) {
              const datesData = await datesRes.json();
              if (!window.theme.pre_order_variant_dates) window.theme.pre_order_variant_dates = {};
              Object.assign(window.theme.pre_order_variant_dates, datesData.variants || {});
            }
          } catch (e) {}
          // Update Pre-Order button after loading
          this.togglePreOrderButton();
          // Update Add to Cart button after pre-order check
          const addButton = document.querySelector(".product-form__submit");
          if (addButton) {
            this.updateAddToCartButtonContent(addButton);
          }
          // If no sizes are selected, keep Add to Cart visible (prevents flashing)
          this.updateOptions && this.updateOptions();
          const opts = this.options || [];
          const colorIdx = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
          const hasEmptySize = opts.some((o, i) => i !== colorIdx && (!o || o.trim() === ''));
          if (hasEmptySize && addButton) addButton.style.display = "block";
        } else {
          this.preOrderProduct = null;
          this.preOrderProductData = null;
          this.togglePreOrderButton();
        }
      } else {
        this.preOrderProduct = null;
        this.preOrderProductData = null;
        this.togglePreOrderButton();
      }
    } catch (error) {
      console.log('Pre-Order product not found or error loading:', error);
      this.preOrderProduct = null;
      this.preOrderProductData = null;
      this.togglePreOrderButton();
    }

    // In "preo" mode size enabling depends on which colors the loaded pre-order
    // product contains, so re-apply the size filter once the fetch settles.
    if (this.disableUnavailableSwatch) {
      this.disableUnavailableSwatch();
    }
    if (this.options && this.formatOptionsData) {
      this.formatOptionsData();
    }
  }

  async updatePreOrderForNewProduct(productHandle, productTags) {
    // Update Pre-Order handle: supports "preo" (parte1-parte2-preo) or classic (handle-pre) format
    let newPreOrderHandle;
    if (window.theme?.pre_order_handle_format === 'preo') {
      const parts = productHandle.split('-');
      newPreOrderHandle = parts.length >= 3 ? `${parts[0]}-${parts[1]}-preo` : `${productHandle}-pre`;
    } else {
      newPreOrderHandle = `${productHandle}-pre`;
    }
    this.preOrderHandle = newPreOrderHandle;
    window.theme.pre_order_handle = newPreOrderHandle;
    
    let hasPreOrderTag = false;
    let preOrderDate = null;
    if (window.theme?.pre_order_handle_format === 'preo') {
      hasPreOrderTag = true;
    } else {
      for (const tag of productTags) {
        if (tag.includes('enable_pre-order')) {
          hasPreOrderTag = true;
          if (tag.includes('enable_pre-order_')) {
            preOrderDate = tag.split('enable_pre-order_')[1];
          }
          break;
        }
      }
    }
    
    this.enablePreOrder = hasPreOrderTag;
    window.theme.enable_pre_order = hasPreOrderTag;
    if (preOrderDate != null) window.theme.pre_order_date = preOrderDate;
    
    // Update country settings from window.theme (these shouldn't change but ensure they're synced)
    this.enablePreOrderNonUSA = window.theme?.enable_pre_order_non_usa || false;
    this.countryCode = window.theme?.country_code || null;

    // Track the load so the pre-order click handler can await it. Otherwise the user can
    // submit the previous color's variant id (which is still cached in dataset/preOrderProduct)
    // during the fetch window.
    const loadPromise = this.loadPreOrderProduct();
    this.preOrderLoadingPromise = loadPromise;
    try {
      await loadPromise;
    } finally {
      if (this.preOrderLoadingPromise === loadPromise) {
        this.preOrderLoadingPromise = null;
      }
    }

    // In 'preo' format, current product has pre-order only if the handle fetch succeeded.
    if (window.theme?.pre_order_handle_format === 'preo') {
      this.enablePreOrder = (this.preOrderProduct != null);
      window.theme.enable_pre_order = this.enablePreOrder;
    }
    
    // Re-disable unavailable swatches with new pre-order status
    this.disableUnavailableSwatch();
    
    // Re-filter variant buttons to update "disabled" class based on pre-order status
    if (this.options) {
      this.formatOptionsData();
    }
    
    // Update Pre-Order button after loading (with delay to ensure variant is updated)
    setTimeout(() => {
      this.togglePreOrderButton();
      // Update Add to Cart button after pre-order check
      const addButton = document.querySelector(".product-form__submit");
      if (addButton) {
        this.updateAddToCartButtonContent(addButton);
      }
      // Verify buttons based on selected size
      if (this.currentVariant) {
        if (this.currentVariant.available) {
          this.enableSubmitBtn();
        } else {
          this.disableSubmitBtn();
        }
      } else {
        // Check if size is selected
        const isSizeSelected = this.isSizeSelected();
        if (isSizeSelected) {
          this.disableSubmitBtn();
        }
      }
    }, 300);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();

    if (!this.currentVariant) {
      // this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.availableSize();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      // Load Pre-Order product if not already loaded and variant is selected
      if (this.preOrderHandle && !this.preOrderProduct) {
        this.loadPreOrderProduct().then(() => {
          this.togglePreOrderButton();
        });
      } else {
        this.togglePreOrderButton();
      }
    }
    this.toggleShowBtn();
    console.log("toggleShowBtn 1");
  }

  showUnavailableButton(addButton, notifyButton) {
    const isSizeSelected = this.isSizeSelected ? this.isSizeSelected() : false;
    if (!addButton) {
      return;
    }
    addButton.style.display = "block";
    addButton.disabled = true;
    
    // Update text
    const textElement = addButton.querySelector(".addtocart-button-text");
    if (textElement) {
      textElement.textContent = "Unavailable";
    } else {
      addButton.textContent = "Unavailable";
    }
    
    // Hide price elements
    const priceWrapper = addButton.querySelector(".addtocart-button-price-wrapper");
    const priceElement = addButton.querySelector(".addtocart-button-price");
    const comparePriceElement = addButton.querySelector(".addtocart-button-compare-price");
    
    if (priceWrapper) {
      priceWrapper.style.setProperty('display', 'none');
    }
    if (priceElement) {
      priceElement.style.display = 'none';
    }
    if (comparePriceElement) comparePriceElement.style.display = 'none';
    
    // Hide status element
    const statusElement = addButton.querySelector(".addtocart-button-status");
    if (statusElement) {
      statusElement.style.display = 'none';
    }
    
    // Hide notify button
    if (notifyButton) {
      notifyButton.classList.add("hide");
      notifyButton.classList.remove("enabled");
    }
  }

  disableSubmitBtn() {
    const isSizeSelected = this.isSizeSelected ? this.isSizeSelected() : false;
    
    if (predictProduct.handle == "digital-gift-card") return;
    const addButton = document.querySelector(".product-form__submit");
    const notifyButton = document.querySelector(".klaviyo-bis-trigger");
    const radioGroups = document.querySelectorAll(".product-form__input:not(.jean-pack)");
    const productForm = document.querySelector(".product-form");
    
    // Check if variant matches selected sizes (for cases where color changed)
    let variantMatchesSelectedSizes = true;
    if (this.currentVariant && isSizeSelected) {
      const selectedOptions = this.options || [];
      const variantOptions = this.currentVariant.options || [];
      const colorIndex = this.getColorOptionIndex();
      
      variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
        if (index === colorIndex || selectedOption === "") {
          return true;
        }
        return variantOptions[index] === selectedOption;
      });
    }
    
    // If all sizes are selected, use handleVariantButtonState to handle special cases
    if (isSizeSelected) {
      // Load pre-order product if needed
      if (this.preOrderHandle && !this.preOrderProduct) {
        this.loadPreOrderProduct().then(() => {
          const handledSpecialCase = this.handleVariantButtonState(isSizeSelected, variantMatchesSelectedSizes, productForm);
          if (!handledSpecialCase) {
            // Variant exists and is available, continue with normal flow
            // (disableSubmitBtn will be called from onVariantChange, so we don't need to do anything here)
          }
        });
        return; // Exit early, will continue after pre-order loads
      }
      
      // Check special cases first
      const handledSpecialCase = this.handleVariantButtonState(isSizeSelected, variantMatchesSelectedSizes, productForm);
      if (handledSpecialCase) {
        return; // Exit early, special cases handled
      }
      // If variant exists and is available, continue with normal flow below
    }
    var showFlag = 0;
    radioGroups.forEach((optionGroup) => {
      const radioInputs = optionGroup.querySelectorAll("input[type='radio']:checked:not(.pack)");

      if (
        optionGroup.dataset.optionName !== "Color" && optionGroup.dataset.optionName !== "Couleur" &&
        radioInputs.length > 0
      ) {
        showFlag++;
      }
    });
    // if exist <fieldset class="js product-form__input" data-option-name="Waist" data-option-index="option2">
    
    let inseamSelector = document.querySelector(".product-form__input[data-option-name='Inseam']");
    let waistSelector = document.querySelector(".product-form__input[data-option-name='Waist']");
   
    if (inseamSelector || waistSelector) {
      let selectedInseam = inseamSelector.querySelector("input[type='radio']:checked");
      let selectedWaist = waistSelector.querySelector("input[type='radio']:checked");
      
      if (showFlag == radioGroups.length - 1) {
        addButton.classList.add("disable-select-size");
        console.log("add disable b 1");
        // Only set "Sold Out" if the current variant is not available
        if (this.currentVariant && !this.currentVariant.available) {
          this.updateAddToCartButtonSoldOut(addButton);
        } else if (this.currentVariant && this.currentVariant.available) {
          // If variant is available, update button content instead
          this.updateAddToCartButtonContent(addButton);
        }
        addButton.disabled = true;
        if (productForm.classList.contains("waitlist-template")) {
          // At this point (if isSizeSelected), variant exists and is available (special cases handled above)
          // If not all sizes selected, check variant existence and availability
          if (!isSizeSelected) {
            if (!this.currentVariant) {
              this.showUnavailableButton(addButton, notifyButton);
            } else if (!this.currentVariant.available) {
              this.updateAddToCartButtonSoldOut(addButton);
              addButton.style.display = "block";
              addButton.disabled = true;
            } else {
              addButton.style.display = "none";
              this.toggleNotifyButton();
            }
          } else {
            // All sizes selected and variant exists and is available
            addButton.style.display = "none";
            // Handle Notify button visibility
            this.toggleNotifyButton();

            if (selectedInseam && selectedWaist) {
              if(selectedInseam.disabled || selectedWaist.disabled) {
                // If size is disabled, hide notify button
                notifyButton.classList.add("hide");
                notifyButton.classList.remove("enabled");
                // Only set "Sold Out" if the current variant is not available
                if (this.currentVariant && !this.currentVariant.available) {
                  this.updateAddToCartButtonSoldOut(addButton);
                } else if (this.currentVariant && this.currentVariant.available) {
                  this.updateAddToCartButtonContent(addButton);
                }
                addButton.disabled = true;
                addButton.style.display = "block";
              }
            }
          }
        } else {
          // At this point (if isSizeSelected), variant exists and is available (special cases handled above)
          // If not all sizes selected, check variant existence and availability
          if (!isSizeSelected) {
            if (!this.currentVariant) {
              this.showUnavailableButton(addButton, notifyButton);
            } else if (!this.currentVariant.available) {
              this.updateAddToCartButtonSoldOut(addButton);
              addButton.style.display = "block";
              addButton.disabled = true;
            } else {
              addButton.style.display = "block";
              this.toggleNotifyButton();
            }
          } else {
            // All sizes selected and variant exists and is available
            addButton.style.display = "block";
            // Handle Notify button visibility
            this.toggleNotifyButton();
          }
        }
      }
    } else if (!document.querySelector("product-pack")) {
      if (showFlag == radioGroups.length - 1) {
        addButton.classList.add("disable-select-size");
        console.log("add disable b 1");
        // Only set "Sold Out" if the current variant is not available
        if (this.currentVariant && !this.currentVariant.available) {
          this.updateAddToCartButtonSoldOut(addButton);
        } else if (this.currentVariant && this.currentVariant.available) {
          // If variant is available, update button content instead
          this.updateAddToCartButtonContent(addButton);
        }
        addButton.disabled = true;
        if (productForm.classList.contains("waitlist-template")) {
          // At this point (if isSizeSelected), variant exists and is available (special cases handled above)
          // If not all sizes selected, check variant existence and availability
          if (!isSizeSelected) {
            if (!this.currentVariant) {
              this.showUnavailableButton(addButton, notifyButton);
            } else if (!this.currentVariant.available) {
              this.updateAddToCartButtonSoldOut(addButton);
              addButton.style.display = "block";
              addButton.disabled = true;
            } else {
              addButton.style.display = "none";
              this.toggleNotifyButton();
            }
          } else {
            // All sizes selected and variant exists and is available
            addButton.style.display = "none";
            // Handle Notify button visibility
            this.toggleNotifyButton();
          }
        } else {
          // At this point (if isSizeSelected), variant exists and is available (special cases handled above)
          // If not all sizes selected, check variant existence and availability
          if (!isSizeSelected) {
            if (!this.currentVariant) {
              this.showUnavailableButton(addButton, notifyButton);
            } else if (!this.currentVariant.available) {
              this.updateAddToCartButtonSoldOut(addButton);
              addButton.style.display = "block";
              addButton.disabled = true;
            } else {
              addButton.style.display = "block";
              this.toggleNotifyButton();
            }
          } else {
            // All sizes selected and variant exists and is available
            addButton.style.display = "block";
            // Handle Notify button visibility
            this.toggleNotifyButton();
          }
        }
      }
    } else {
      console.log("showFlag" + showFlag);
      console.log("(radioGroups.length - 2)");
      console.log(radioGroups.length - 2);
      if (showFlag == radioGroups.length - 2) {
        addButton.classList.add("disable-select-size");
        console.log("add disable b 1");
        // Only set "Sold Out" if the current variant is not available
        if (this.currentVariant && !this.currentVariant.available) {
          this.updateAddToCartButtonSoldOut(addButton);
        } else if (this.currentVariant && this.currentVariant.available) {
          // If variant is available, update button content instead
          this.updateAddToCartButtonContent(addButton);
        }
        addButton.disabled = true;
        if (productForm.classList.contains("waitlist-template")) {
          // At this point (if isSizeSelected), variant exists and is available (special cases handled above)
          // If not all sizes selected, check variant existence and availability
          if (!isSizeSelected) {
            if (!this.currentVariant) {
              this.showUnavailableButton(addButton, notifyButton);
            } else if (!this.currentVariant.available) {
              this.updateAddToCartButtonSoldOut(addButton);
              addButton.style.display = "block";
              addButton.disabled = true;
            } else {
              addButton.style.display = "none";
              this.toggleNotifyButton();
            }
          } else {
            // All sizes selected and variant exists and is available
            addButton.style.display = "none";
            // Handle Notify button visibility
            this.toggleNotifyButton();

            // get the selected size 
            let selectedSize = document.querySelector(".product-form__input[data-option-name='Size'] input[type='radio']:checked");
            if (selectedSize) {
              if(selectedSize.disabled) {
                // If size is disabled, hide notify button
                notifyButton.classList.add("hide");
                notifyButton.classList.remove("enabled");
                // Only set "Sold Out" if the current variant is not available
                if (this.currentVariant && !this.currentVariant.available) {
                  this.updateAddToCartButtonSoldOut(addButton);
                } else if (this.currentVariant && this.currentVariant.available) {
                  this.updateAddToCartButtonContent(addButton);
                }
                addButton.disabled = true;
                addButton.style.display = "block";
              }
            }
          }
        } else {
          // At this point (if isSizeSelected), variant exists and is available (special cases handled above)
          // If not all sizes selected, check variant existence and availability
          if (!isSizeSelected) {
            if (!this.currentVariant) {
              this.showUnavailableButton(addButton, notifyButton);
            } else if (!this.currentVariant.available) {
              this.updateAddToCartButtonSoldOut(addButton);
              addButton.style.display = "block";
              addButton.disabled = true;
            } else {
              addButton.style.display = "block";
              this.toggleNotifyButton();
            }
          } else {
            // All sizes selected and variant exists and is available
            addButton.style.display = "block";
            // Handle Notify button visibility
            this.toggleNotifyButton();
          }
        }
      }
    }



  }
  enableSubmitBtn() {
    const isSizeSelected = this.isSizeSelected ? this.isSizeSelected() : false;
    
    // IMPORTANT: If sizes are selected, verify that variant matches before enabling button
    if (isSizeSelected && this.currentVariant) {
      const selectedOptions = this.options || [];
      const variantOptions = this.currentVariant.options || [];
      const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
      
      const variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
        if (index === colorIndex || selectedOption === "") {
          return true; // Color or empty option, skip
        }
        return variantOptions[index] === selectedOption;
      });
      
      if (!variantMatchesSelectedSizes) {
        this.currentVariant = null;
        // Show "Unavailable" button instead
        const addButton = document.querySelector(".product-form__submit");
        const notifyButton = document.querySelector(".klaviyo-bis-trigger");
        if (addButton) {
          this.showUnavailableButton(addButton, notifyButton);
        }
        // Don't enable button if variant doesn't match selected sizes
        return;
      }
    }
    
    const addButton = document.querySelector(".product-form__submit");
    const preOrderButton = document.querySelector(".product-form__preorder-submit");
    const notifyButton = document.querySelector(".klaviyo-bis-trigger");
    const productForm = document.querySelector(".product-form");
    addButton.classList.remove("disable-select-size");
    console.log("remove disable b 1");
    addButton.style.display = "block";
    if (productForm.classList.contains("preorder-template")) {
      var preOrderQuantity = 0;
      for (var i = 0; i < this.relatedInventoryStatus.length; i++) {
        const product = this.relatedInventoryStatus[i];
        var selectedVariant = product.inventory.find((variant) => {
          if (variant.id == this.currentVariant.id) {
            return variant;
          }
        });
        if (selectedVariant) {
          preOrderQuantity = selectedVariant.quantity;
        }
      }

      if (this.preorderMessage) {
        this.preorderMessage.style.display = "none";
      }

      if (preOrderQuantity <= 0) {
        // Update button to show Pre-Order but keep structure
        const textElement = addButton.querySelector(".addtocart-button-text");
        const statusElement = addButton.querySelector(".addtocart-button-status");
        if (textElement) {
          textElement.textContent = "Add Pre-Order";
        }
        if (statusElement) {
          statusElement.style.display = 'none';
        }
        
        var preOrderInput = document.createElement("input");
        preOrderInput.setAttribute("id", "preorder-property");
        preOrderInput.setAttribute("type", "hidden");
        preOrderInput.setAttribute("name", "properties[preorder]");
        if (this.preorderMessage) {
          this.preorderMessage.style.display = "block";
          preOrderInput.setAttribute("value", this.preorderMessage.innerText);
        }

        productForm.querySelector("form").prepend(preOrderInput);
      } else {
        const preOrderInput = productForm.querySelector("#preorder-property");
        if (preOrderInput) {
          preOrderInput.remove();
        }
      }
    }
    addButton.disabled = false;
    
    // IMPORTANT: Before updating button content, check if variant matches selected sizes
    const isSizeSelectedCheck = this.isSizeSelected ? this.isSizeSelected() : false;
    if (isSizeSelectedCheck && this.currentVariant) {
      const selectedOptions = this.options || [];
      const variantOptions = this.currentVariant.options || [];
      const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
      
      const variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
        if (index === colorIndex || selectedOption === "") {
          return true; // Color or empty option, skip
        }
        return variantOptions[index] === selectedOption;
      });
      
      if (!variantMatchesSelectedSizes) {
        // Don't update button content if variant doesn't match - showUnavailableButton was already called
        return;
      }
    }
    
    // Handle Pre-Order button visibility
    this.togglePreOrderButton();
    
    // Handle Notify button visibility
    this.toggleNotifyButton();
    
    // Update Add to Cart button once at the end after all operations
    this.updateAddToCartButtonContent(addButton);
  }

  updateAddToCartButtonContent(button) {
    if (!button) return;
    
    const textElement = button.querySelector(".addtocart-button-text");
    const priceElement = button.querySelector(".addtocart-button-price");
    const comparePriceElement = button.querySelector(".addtocart-button-compare-price");
    const statusElement = button.querySelector(".addtocart-button-status");
    
    // Check if size is selected FIRST, before trying to get variant from form or updating content
    // IMPORTANT: Re-check isSizeSelected multiple times as it can change during async operations
    let isSizeSelected = this.isSizeSelected ? this.isSizeSelected() : false;
    
    // PRIORITY: If sizes are selected, check variant existence and match BEFORE updating content
    if (isSizeSelected) {
      // First check if variant doesn't exist
      if (!this.currentVariant) {
        if (textElement) {
          textElement.textContent = "Unavailable";
        } else {
          button.textContent = "Unavailable";
        }
        button.disabled = true;
        // Hide price and status
        if (priceElement) priceElement.style.display = 'none';
        if (comparePriceElement) comparePriceElement.style.display = 'none';
        if (statusElement) statusElement.style.display = 'none';
        const priceWrapper = button.querySelector(".addtocart-button-price-wrapper");
        if (priceWrapper) priceWrapper.style.display = 'none';
        return;
      }
      
      // Then check if variant matches selected sizes
      const selectedOptions = this.options || [];
      const variantOptions = this.currentVariant.options || [];
      const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
      
      const variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
        if (index === colorIndex || selectedOption === "") {
          return true; // Color or empty option, skip
        }
        return variantOptions[index] === selectedOption;
      });
      
      if (!variantMatchesSelectedSizes) {
        if (textElement) {
          textElement.textContent = "Unavailable";
        } else {
          button.textContent = "Unavailable";
        }
        button.disabled = true;
        // Hide price and status
        if (priceElement) priceElement.style.display = 'none';
        if (comparePriceElement) comparePriceElement.style.display = 'none';
        if (statusElement) statusElement.style.display = 'none';
        const priceWrapper = button.querySelector(".addtocart-button-price-wrapper");
        if (priceWrapper) priceWrapper.style.display = 'none';
        return;
      }
    }
    
    // If currentVariant is not available yet, try to get it from the form (but verify match if sizes are selected)
    if (!this.currentVariant) {
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        const variantId = parseInt(variantInput.value);
        const variantData = this.getVariantData();
        const foundVariant = variantData.find(v => v.id === variantId);
        
        // IMPORTANT: If sizes are selected, verify that variant matches BEFORE setting it
        if (isSizeSelected && foundVariant) {
          const selectedOptions = this.options || [];
          const variantOptions = foundVariant.options || [];
          const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
          
          const variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
            if (index === colorIndex || selectedOption === "") {
              return true; // Color or empty option, skip
            }
            return variantOptions[index] === selectedOption;
          });
          
          if (!variantMatchesSelectedSizes) {
            // Don't set currentVariant if it doesn't match - show "Unavailable" immediately
            if (textElement) {
              textElement.textContent = "Unavailable";
            } else {
              button.textContent = "Unavailable";
            }
            button.disabled = true;
            // Hide price and status
            if (priceElement) priceElement.style.display = 'none';
            if (comparePriceElement) comparePriceElement.style.display = 'none';
            if (statusElement) statusElement.style.display = 'none';
            const priceWrapper = button.querySelector(".addtocart-button-price-wrapper");
            if (priceWrapper) priceWrapper.style.display = 'none';
            return;
          }
        }
        
        // Only set currentVariant if it matches or if no sizes are selected
        this.currentVariant = foundVariant;
      }
    }
    
    // Re-check isSizeSelected after potentially setting currentVariant from input
    // This is critical because isSizeSelected can change during async operations
    isSizeSelected = this.isSizeSelected ? this.isSizeSelected() : false;
    
    // If sizes are selected but variant doesn't exist or doesn't match, show "Unavailable"
    if (isSizeSelected) {
      if (!this.currentVariant) {
        if (textElement) {
          textElement.textContent = "Unavailable";
        } else {
          button.textContent = "Unavailable";
        }
        button.disabled = true;
        // Hide price and status
        if (priceElement) priceElement.style.display = 'none';
        if (comparePriceElement) comparePriceElement.style.display = 'none';
        if (statusElement) statusElement.style.display = 'none';
        const priceWrapper = button.querySelector(".addtocart-button-price-wrapper");
        if (priceWrapper) priceWrapper.style.display = 'none';
        return;
      }
      
      // Verify variant matches selected sizes
      const selectedOptions = this.options || [];
      const variantOptions = this.currentVariant.options || [];
      const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
      
      const variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
        if (index === colorIndex || selectedOption === "") {
          return true; // Color or empty option, skip
        }
        return variantOptions[index] === selectedOption;
      });
      
      if (!variantMatchesSelectedSizes) {
        if (textElement) {
          textElement.textContent = "Unavailable";
        } else {
          button.textContent = "Unavailable";
        }
        button.disabled = true;
        // Hide price and status
        if (priceElement) priceElement.style.display = 'none';
        if (comparePriceElement) comparePriceElement.style.display = 'none';
        if (statusElement) statusElement.style.display = 'none';
        const priceWrapper = button.querySelector(".addtocart-button-price-wrapper");
        if (priceWrapper) priceWrapper.style.display = 'none';
        return;
      }
    }
    
    // If button doesn't have the new structure, try to update text directly
    if (!textElement && !priceElement) {
      // Fallback: only destroy structure when NEITHER element exists (truly flat button)
      if (this.currentVariant && this.currentVariant.available) {
        button.textContent = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
      } else if (this.currentVariant && !this.currentVariant.available) {
        button.textContent = "Sold Out";
      }
      return;
    }
    
    // Check if button has disable-select-size class (indicates size not fully selected)
    const hasDisableSelectSize = button.classList.contains("disable-select-size");
    
    // Update text
    if (textElement) {
      // CRITICAL: Re-check isSizeSelected one more time before setting text
      // This prevents showing "Add to Cart" when sizes are actually selected
      const isSizeSelectedForText = this.isSizeSelected ? this.isSizeSelected() : false;
      
      // Only show "Sold Out" if:
      // 1. A size is selected (not just default variant)
      // 2. Button doesn't have disable-select-size class (size is fully selected)
      // 3. The variant exists but is not available
      if (!hasDisableSelectSize && isSizeSelectedForText && this.currentVariant && !this.currentVariant.available) {
        textElement.textContent = "Sold Out";
      } else if (this.currentVariant && this.currentVariant.available) {
        // IMPORTANT: Verify variant matches selected sizes before showing "Add to Cart"
        // Use isSizeSelectedForText which was just re-checked
        if (isSizeSelectedForText) {
          const selectedOptions = this.options || [];
          const variantOptions = this.currentVariant.options || [];
          const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
          
          const variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
            if (index === colorIndex || selectedOption === "") {
              return true; // Color or empty option, skip
            }
            return variantOptions[index] === selectedOption;
          });
          
          if (!variantMatchesSelectedSizes) {
            textElement.textContent = "Unavailable";
            button.disabled = true;
            return;
          }
        }
        textElement.textContent = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
      } else {
        // If no size is selected or size is not fully selected, show "Add to Cart" instead of "Sold Out"
        textElement.textContent = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
      }
    }
    
    // Update price - show when product has pre-order (uses hasPreOrderAvailable() for current state when changing colors)
    const priceWrapper = button.querySelector(".addtocart-button-price-wrapper");
    const hasPreOrder = this.hasPreOrderAvailableFlag || (this.hasPreOrderAvailable && this.hasPreOrderAvailable());
    // ATC must always show ORIGINAL product price (in stock). When no size selected but color has pre-order, use first variant of ORIGINAL product for that color.
    let priceReferenceVariant = this.currentVariant;
    if (!priceReferenceVariant && this.getVariantData) {
      const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
      const currentColor = (this.options && this.options[colorIndex]) || '';
      const variantData = this.getVariantData();
      priceReferenceVariant = (variantData && currentColor.trim()) ? variantData.find(v => {
        if (!v.options || v.options[colorIndex] == null) return false;
        return (v.options[colorIndex] || '').trim() === currentColor.trim();
      }) || null : null;
    }
    const showPriceForPreOrder = hasPreOrder && priceElement && priceReferenceVariant;

    const applyAtcPriceFromVariant = (variant) => {
      if (!variant || !priceElement) return;
      const price = variant.price / 100;
      const compareAtPrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
      const currencySymbol = window.theme?.cart_currency_symbol || '$';
      const shopCurrency = window.theme?.shop_currency || '';

      if (comparePriceElement && compareAtPrice && compareAtPrice > price) {
        comparePriceElement.innerHTML = `<s>${currencySymbol}${Shopify.formatMoneyAmmount(compareAtPrice)} ${shopCurrency}</s> `;
        comparePriceElement.style.display = 'inline';
      } else if (comparePriceElement) {
        comparePriceElement.textContent = '';
        comparePriceElement.style.display = 'none';
      }

      priceElement.textContent = `${currencySymbol}${Shopify.formatMoneyAmmount(price)} ${shopCurrency}`;
      priceElement.style.removeProperty('display');

      const pid = (typeof predictProduct !== 'undefined' && predictProduct && predictProduct.id) ? predictProduct.id : null;
      if (pid != null && priceElement.dataset) priceElement.dataset.productId = String(pid);
      if (comparePriceElement && comparePriceElement.dataset && pid != null) {
        comparePriceElement.dataset.productId = String(pid);
      }
    };

    if (showPriceForPreOrder) {
      if (priceWrapper) {
        priceWrapper.style.removeProperty('display');
        priceWrapper.style.display = 'inline';
      }
      applyAtcPriceFromVariant(priceReferenceVariant);
    } else if (priceElement && priceReferenceVariant) {
      applyAtcPriceFromVariant(priceReferenceVariant);
      if (priceWrapper) priceWrapper.style.setProperty('display', 'none');
    } else {
      if (priceWrapper) {
        priceWrapper.style.setProperty('display', 'none');
      }
      if (comparePriceElement) comparePriceElement.style.display = 'none';
    }

    // Update status - show when showing ATC price in pre-order context (whenever we show in-stock price)
    if (statusElement) {
      if (hasPreOrder) statusElement.textContent = "In Stock. Ready to Ship.";
      if (showPriceForPreOrder) statusElement.style.removeProperty('display');
      else statusElement.style.setProperty('display', 'none');
    }
  }

  updateAddToCartButtonSoldOut(button) {
    if (!button) return;
    
    const textElement = button.querySelector(".addtocart-button-text");
    const priceElement = button.querySelector(".addtocart-button-price");
    const comparePriceElement = button.querySelector(".addtocart-button-compare-price");
    const statusElement = button.querySelector(".addtocart-button-status");
    
    // If button doesn't have the new structure, use old format
    // BUT: Don't destroy the structure if priceElement exists (structure might be partially there)
    if (!textElement && !priceElement) {
      button.innerHTML = "Sold Out";
      return;
    }
    
    // Update text - preserve structure
    if (textElement) {
      textElement.textContent = "Sold Out";
    } else {
      // If textElement doesn't exist but button exists, update button text directly without destroying structure
      button.textContent = "Sold Out";
    }
    
    // Hide price and status for sold out
    if (priceElement) priceElement.style.display = 'none';
    if (comparePriceElement) comparePriceElement.style.display = 'none';
    const priceWrapper = button.querySelector(".addtocart-button-price-wrapper");
    if (priceWrapper) priceWrapper.style.setProperty('display', 'none');
    if (statusElement) {
      statusElement.style.setProperty('display', 'none');
    }
  }

  toggleNotifyButton() {
    const isSizeSelected = this.isSizeSelected ? this.isSizeSelected() : false;
    
    const notifyButton = document.querySelector(".klaviyo-bis-trigger");
    if (!notifyButton) return;

    const productForm = document.querySelector(".product-form");
    const preOrderButton = document.querySelector(".product-form__preorder-submit");
    
    // Hide notify button by default
    notifyButton.classList.add("hide");
    notifyButton.classList.remove("enabled");
    
    // If pre-order button is visible, always hide notify button
    if (preOrderButton && !preOrderButton.classList.contains("hidden")) {
      return;
    }
    
    // Check if variant matches selected sizes (to avoid showing notify when variant doesn't match)
    let variantMatchesSelectedSizes = true;
    if (this.currentVariant && isSizeSelected) {
      const selectedOptions = this.options || [];
      const variantOptions = this.currentVariant.options || [];
      const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
      
      variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
        // Skip color comparison
        if (index === colorIndex || selectedOption === "") {
          return true; // Color or empty option, skip
        }
        return variantOptions[index] === selectedOption;
      });
    }
    
    // Show notify button only if:
    // 1. A variant is selected (currentVariant exists)
    // 2. Variant matches selected sizes
    // 3. Variant is not available (sold out)
    // 4. Product form has waitlist-template class
    // 5. Variant has waitlist available (not disabled by dwl_ tag)
    // 6. Pre-order button is NOT visible
    const waitlistAvailable = this.hasWaitlistAvailable();
    const shouldShow = this.currentVariant && variantMatchesSelectedSizes && !this.currentVariant.available && productForm && productForm.classList.contains("waitlist-template") && waitlistAvailable;
    if (shouldShow) {
      notifyButton.classList.remove("hide");
      notifyButton.classList.add("enabled");
      notifyButton.dataset.variantId = this.currentVariant.id;
    }
  }

  /**
   * Check if pre-order is available for the current country
   * @param {boolean} checkPreOrderProduct - Whether to check if preOrderProduct exists (default: true)
   * @returns {boolean} - True if pre-order is available for current country, false otherwise
   */
  isPreOrderAvailableForCountry(checkPreOrderProduct = true) {
    // Check if pre-order is enabled
    const tags = this.dataset?.tags || '';
    const hasPreOrderTag = tags && (tags.includes('enable_pre-order') || tags.includes('enable_pre-order_'));
    const isPreOrderEnabled = this.enablePreOrder || hasPreOrderTag || window.theme?.enable_pre_order;
    
    if (!isPreOrderEnabled) {
      return false;
    }
    
    // Check if pre-order product exists (if required)
    if (checkPreOrderProduct && !this.preOrderProduct) {
      return false;
    }
    
    // Check country restrictions
    const countryCode = window.theme?.country_code || this.countryCode;
    const enablePreOrderNonUSA = window.theme?.enable_pre_order_non_usa !== undefined 
      ? window.theme.enable_pre_order_non_usa 
      : this.enablePreOrderNonUSA;
    const isUSA = countryCode === 'US';
    const canShowPreOrder = isUSA || enablePreOrderNonUSA;
    
    return canShowPreOrder;
  }

  togglePreOrderButton() {
    const isSizeSelected = this.isSizeSelected ? this.isSizeSelected() : false;
    
    const preOrderButton = document.querySelector(".product-form__preorder-submit");
    if (!preOrderButton) {
      // If no pre-order button exists, set flag to false
      this.hasPreOrderAvailableFlag = false;
      return;
    }

    const productForm = document.querySelector(".product-form");
    
    // Hide Pre-Order button by default
    preOrderButton.classList.add("hidden");
    // Set flag to false by default
    this.hasPreOrderAvailableFlag = false;
    
    // Early return if no pre-order product exists
    if (!this.preOrderProduct) {
      return;
    }

    // If pre-order matches by color, only show when current color exists in pre-order product
    // (e.g. pre-order has only White, Black, Navy → Bone should not show the button)
    if (window.theme?.pre_order_match_by_color === true && !this.currentColorExistsInPreOrderProduct()) {
      return;
    }

    // Check country restrictions
    if (!this.isPreOrderAvailableForCountry(true)) {
      return; // Hide button if not available for current country
    }
    
    // Check if pre-order is enabled or if it's a waitlist scenario
    const waitlistEnabled = productForm.classList.contains("waitlist-template");
    const shouldShowPreOrder = 
      this.enablePreOrder || 
      (this.currentVariant && !this.currentVariant.available && waitlistEnabled);

    if (!shouldShowPreOrder) {
      return;
    }

    // Try to find matching variant BEFORE showing the button
    const matchingPreOrderVariant = this.findMatchingPreOrderVariant();

    if (matchingPreOrderVariant && matchingPreOrderVariant.available) {
      // Matching variant: show button enabled with variant and price
      preOrderButton.classList.remove("hidden");
      preOrderButton.style.removeProperty('display');
      this.hasPreOrderAvailableFlag = true;
      preOrderButton.dataset.preOrderVariantId = matchingPreOrderVariant.id;
      this.updatePreOrderButtonContent(preOrderButton, matchingPreOrderVariant);
    } else if (
      !isSizeSelected &&
      this.preOrderProduct &&
      this.enablePreOrder &&
      this.currentColorExistsInPreOrderProduct()
    ) {
      preOrderButton.classList.remove("hidden");
      preOrderButton.style.removeProperty('display');
      this.hasPreOrderAvailableFlag = true;
      delete preOrderButton.dataset.preOrderVariantId;
      const textEl = preOrderButton.querySelector(".preorder-button-text");
      if (textEl) textEl.textContent = "Add Pre-Order";
      // Populate price from a representative pre-order variant so the button shows price
      // even without size selected (e.g. after switching to a fit that has pre-order).
      const representativeVariant = this.findRepresentativePreOrderVariant
        ? this.findRepresentativePreOrderVariant()
        : null;
      if (representativeVariant) {
        this.updatePreOrderButtonContent(preOrderButton, representativeVariant);
      }
      // Set Add to Cart button layout (price/wrapper) for pre-order
      const addButton = document.querySelector(".product-form__submit");
      if (addButton) this.updateAddToCartButtonContent(addButton);
    } else {
      // No matching variant (e.g. combination not available)
      preOrderButton.classList.add("hidden");
      delete preOrderButton.dataset.preOrderVariantId;
      this.hasPreOrderAvailableFlag = false;
    }

    // Hide notify button when pre-order button is shown, show it if pre-order is not available
    this.toggleNotifyButton();
  }

  isSizeSelected() {
    const waistFieldset = document.querySelector(
      'variant-radios fieldset[data-option-name="Waist"], #variant-radios-single-wrapper fieldset[data-option-name="Waist"], .product-form fieldset[data-option-name="Waist"]'
    );
    const inseamFieldset = document.querySelector(
      'variant-radios fieldset[data-option-name="Inseam"], #variant-radios-single-wrapper fieldset[data-option-name="Inseam"], .product-form fieldset[data-option-name="Inseam"]'
    );
    if (waistFieldset && inseamFieldset) {
      const w = waistFieldset.querySelector('input[type="radio"]:checked');
      const i = inseamFieldset.querySelector('input[type="radio"]:checked');
      return !!(w && String(w.value).trim() && i && String(i.value).trim());
    }

    // Check for radio buttons (variant-radios)
    const sizeOptionGroups = document.querySelectorAll('.product-form__input[data-option-name="Size"], .product-form__input[data-option-name="size"]');
    
    if (sizeOptionGroups.length > 0) {
      return Array.from(sizeOptionGroups).some(group => {
        const checkedSize = group.querySelector('input[type="radio"]:checked');
        return checkedSize && checkedSize.value;
      });
    }
    
    // Check selects (variant-selects)
    const mainProductInfo = document.getElementById("main-product-info");
    if (mainProductInfo) {
      try {
        const productInfo = JSON.parse(mainProductInfo.innerHTML);
        const optionsNames = productInfo.options_names || [];
        const sizeIndex = optionsNames.findIndex(name => {
          const lowerName = name.toLowerCase();
          return lowerName === 'size' || lowerName === 'talla';
        });
        
        if (sizeIndex >= 0) {
          const sizeSelect = document.querySelector(`#Option-${this.dataset.section}-${sizeIndex}, #SingleOptionSelector-${sizeIndex}`);
          if (sizeSelect && sizeSelect.value) {
            const firstOption = sizeSelect.options[0];
            return firstOption && sizeSelect.value !== firstOption.value;
          }
        }
      } catch (e) {
        // Fall through to currentVariant check
      }
    }
    
    // Fallback: usar opciones del variant cuando el producto tiene Waist+Inseam en schema
    if (this.currentVariant && this.currentVariant.options) {
      const opts = this.currentVariant.options;
      if (mainProductInfo) {
        try {
          const productInfo = JSON.parse(mainProductInfo.innerHTML);
          const names = (productInfo.options_names || []).map((n) => String(n).toLowerCase());
          const wi = names.indexOf('waist');
          const ii = names.indexOf('inseam');
          if (wi >= 0 && ii >= 0) {
            const wv = opts[wi];
            const iv = opts[ii];
            return !!(wv && String(wv).trim() && iv && String(iv).trim());
          }
        } catch (e) {
          // ignore
        }
      }
      const sizeValue = this.currentVariant.option2 || this.currentVariant.option1;
      return !!(sizeValue && sizeValue.trim() !== '');
    }
    
    return false;
  }

  updatePreOrderButtonContent(button, variant) {
    const priceElement = button.querySelector(".preorder-button-price");
    const comparePriceElement = button.querySelector(".preorder-button-compare-price");

    // Update data-product-id with PRE-ORDER product ID (not original product ID)
    const preOrderProductId = this.preOrderProduct?.id || null;
    if (priceElement && preOrderProductId) {
      priceElement.setAttribute('data-product-id', preOrderProductId);
    }
    if (comparePriceElement && preOrderProductId) {
      comparePriceElement.setAttribute('data-product-id', preOrderProductId);
    }

    if (!variant) return;

    // M&B Club VIP discount: the .price__vip element is only rendered server-side for
    // members, so its presence signals the customer is VIP. Mirror updatePriceSnippets().
    // For VIP the discounted price is the effective price and the original the compare-at.
    let price = variant.price / 100; // Convert from cents to dollars
    let compareAt = variant.compare_at_price ? variant.compare_at_price / 100 : null;
    const vipDiscountPercent = getMbClubVipDiscountPercent();
    if (vipDiscountPercent > 0) {
      compareAt = price;
      price = Math.ceil((price - (price * vipDiscountPercent) / 100) * 100) / 100;
    }

    // Estimated ship date: use variant-specific arrival date if available, fallback to tag date
    const variantArrivalDate = window.theme?.pre_order_variant_dates?.[String(variant.id)] || null;
    const dateToUse = variantArrivalDate || window.theme?.pre_order_date || null;
    const shipDate = dateToUse ? this.formatPreOrderDate(dateToUse) : null;

    renderPreorderButtonContent(button, { price, compareAt, shipDate });
  }

  formatPreOrderDate(dateString) {
    if (!dateString) return null;
    
    try {
      // Parse date string (format: YYYY-MM-DD)
      const date = new Date(dateString + 'T00:00:00');
      if (isNaN(date.getTime())) return null;
      
      // Format to "Feb 15" format
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = months[date.getMonth()];
      const day = date.getDate();
      
      return `${month} ${day}`;
    } catch (error) {
      console.error('Error formatting pre-order date:', error);
      return null;
    }
  }

  findMatchingPreOrderVariant() {
    if (!this.preOrderProduct) {
      return null;
    }

    // Use currentVariant options if available, otherwise use selected options
    let currentOptions = [];
    if (this.currentVariant && this.currentVariant.options) {
      currentOptions = this.currentVariant.options;
    } else {
      // Use selected options from form
      currentOptions = this.options || [];
    }

    if (currentOptions.length === 0) {
      return null;
    }

    const mainProductInfo = document.getElementById("main-product-info");
    if (!mainProductInfo) {
      return null;
    }
    
    const productInfo = JSON.parse(mainProductInfo.innerHTML);
    const optionsNames = productInfo.options_names || [];
    
    // "preo" method: 1 pre-order product with all colors → match by color + size.
    // Classic method: 1 pre-order product per color → match by all options except color.
    const matchByColor = window.theme?.pre_order_match_by_color === true;
    const colorIndex = optionsNames.findIndex(name => {
      const lowerName = name.toLowerCase();
      return lowerName === 'color' || lowerName === 'couleur';
    });
    
    return this.preOrderProduct.variants.find(variant => {
      if (!variant.options || variant.options.length !== currentOptions.length) {
        return false;
      }
      
      for (let i = 0; i < currentOptions.length; i++) {
        if (!matchByColor && i === colorIndex) continue;
        if (variant.options[i] !== currentOptions[i]) {
          return false;
        }
      }
      return true;
    }) || null;
  }

  /**
   * Finds a representative pre-order variant to use as a price reference when the
   * exact variant cannot be resolved (e.g. size not selected after switching fits).
   * Priority: available variant for the current color → any variant for the current color
   * → first available variant → first variant.
   */
  findRepresentativePreOrderVariant() {
    if (!this.preOrderProduct || !this.preOrderProduct.variants || !this.preOrderProduct.variants.length) {
      return null;
    }

    const variants = this.preOrderProduct.variants;
    const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
    const currentColor = ((this.options && this.options[colorIndex]) ||
      (this.currentVariant && this.currentVariant.options && this.currentVariant.options[colorIndex]) || '').trim();

    if (currentColor) {
      const availableSameColor = variants.find(v => v.available && v.options && (v.options[colorIndex] || '').trim() === currentColor);
      if (availableSameColor) return availableSameColor;
      const anySameColor = variants.find(v => v.options && (v.options[colorIndex] || '').trim() === currentColor);
      if (anySameColor) return anySameColor;
    }

    return variants.find(v => v.available) || variants[0] || null;
  }

  /**
   * Checks whether the current product color exists in the pre-order product.
   * If pre-order only has White, Black, Navy and current product is Bone, returns false.
   */
  currentColorExistsInPreOrderProduct() {
    if (!this.preOrderProduct || !this.preOrderProduct.variants || !this.preOrderProduct.variants.length) {
      return false;
    }
    const matchByColor = window.theme?.pre_order_match_by_color === true;
    if (!matchByColor) {
      return true; // classic method: do not filter by color
    }
    const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
    const currentColor = (this.options && this.options[colorIndex]) ||
      (this.currentVariant && this.currentVariant.options && this.currentVariant.options[colorIndex]);
    if (!currentColor || !currentColor.trim()) {
      return false;
    }
    const normalizedCurrent = currentColor.trim();
    return this.preOrderProduct.variants.some(v => {
      if (!v.options || v.options.length <= colorIndex) return false;
      return (v.options[colorIndex] || '').trim() === normalizedCurrent;
    });
  }

  /**
   * Pre-order can only rescue a sold-out size when it applies to the current selection:
   * enabled, allowed for the country and, in "preo" mode (1 pre-order product with all
   * colors), the current color exists in the pre-order product.
   */
  preOrderAppliesToCurrentSelection() {
    const tags = this.dataset?.tags || '';
    const hasPreOrderTag = tags.includes('enable_pre-order');
    const isPreOrderEnabled = this.enablePreOrder || hasPreOrderTag || window.theme?.enable_pre_order;
    if (!isPreOrderEnabled || !this.isPreOrderAvailableForCountry(false)) {
      return false;
    }
    if (window.theme?.pre_order_match_by_color === true) {
      return this.currentColorExistsInPreOrderProduct();
    }
    return true;
  }

  /**
   * Like findMatchingPreOrderVariant() but for an arbitrary option combination,
   * so the size filter can check variants other than the currently selected one.
   */
  findPreOrderVariantForOptions(optionValues) {
    if (!this.preOrderProduct || !this.preOrderProduct.variants) {
      return null;
    }
    const matchByColor = window.theme?.pre_order_match_by_color === true;
    const colorIndex = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
    return this.preOrderProduct.variants.find((variant) => {
      if (!variant.options || variant.options.length !== optionValues.length) {
        return false;
      }
      for (let i = 0; i < optionValues.length; i++) {
        if (!matchByColor && i === colorIndex) continue;
        if (variant.options[i] !== optionValues[i]) {
          return false;
        }
      }
      return true;
    }) || null;
  }

  /**
   * A size counts as selectable when its own variant has stock, or when the pre-order
   * product has an available variant for the same option combination. A size whose
   * variant is missing from the pre-order product, or sold out there too, keeps the
   * normal disabled behavior even on a pre-order color.
   */
  isVariantOrPreOrderAvailable(variant) {
    if (!variant) {
      return false;
    }
    if (variant.available === true) {
      return true;
    }
    if (this.isMultibundle || !this.preOrderAppliesToCurrentSelection()) {
      return false;
    }
    const preOrderVariant = this.findPreOrderVariantForOptions(variant.options || []);
    return preOrderVariant != null && preOrderVariant.available === true;
  }

  // Centralized function to handle button state based on variant and pre-order availability
  // Returns true if handled a special case (pre-order, unavailable, sold out), false if should continue with normal flow
  handleVariantButtonState(isSizeSelected, variantMatchesSelectedSizes, productForm) {
    if (document.querySelector("multi-bundle")) return true;
    // Gift cards don't have a Color option; their single option (Denominations) at index 0 gets
    // mistakenly treated as "color" by getColorOptionIndex() → hasEmptySize stays false → shows
    // "Unavailable" before any denomination is selected. Return early so the button stays enabled.
    if (productForm && productForm.classList.contains("giftcard-form") && !this.currentVariant) {
      const addButton = document.querySelector(".product-form__submit");
      if (addButton) addButton.style.display = "block";
      return false;
    }

    // Never hide Add to Cart when no sizes are selected (this.options has '' in Waist/Inseam)
    // isSizeSelected can be true if currentVariant comes from input, but this.options reflects the real DOM
    this.updateOptions && this.updateOptions();
    const opts = this.options || [];
    const colorIdx = this.getColorOptionIndex ? this.getColorOptionIndex() : 0;
    const hasEmptySize = opts.some((o, i) => i !== colorIdx && (!o || o.trim() === ''));
    if (hasEmptySize) {
      const addButton = document.querySelector(".product-form__submit");
      if (addButton) addButton.style.display = "block";
      return false;
    }

    // PRIORITY 1: Check if pre-order is available for this combination
    const preOrderAvailable = this.hasPreOrderAvailable();

    if (preOrderAvailable) {
      // Pre-order available: keep Add to Cart visible (as "Sold Out" if main variant
      // is unavailable, otherwise normal) and show pre-order button alongside it.
      const addButton = document.querySelector(".product-form__submit");
      const notifyButton = document.querySelector(".klaviyo-bis-trigger");
      const preOrderButton = document.querySelector(".product-form__preorder-submit");

      if (notifyButton) {
        notifyButton.classList.add("hide");
      }

      if (preOrderButton) {
        const matchingPreOrderVariant = this.findMatchingPreOrderVariant();
        if (matchingPreOrderVariant) {
          preOrderButton.classList.remove("hidden");
          preOrderButton.style.removeProperty('display');
          preOrderButton.dataset.preOrderVariantId = matchingPreOrderVariant.id;
          this.updatePreOrderButtonContent(preOrderButton, matchingPreOrderVariant);
          this.hasPreOrderAvailableFlag = true;
        }
      }

      // If the main variant is sold out, show ATC as "Sold Out" (visible, disabled).
      const variantExists = this.currentVariant && variantMatchesSelectedSizes;
      const variantAvailable = variantExists && this.currentVariant.available === true;
      if (variantExists && !variantAvailable && addButton) {
        addButton.style.display = "block";
        addButton.disabled = true;
        this.updateAddToCartButtonSoldOut(addButton);
        return true;
      }

      // Main variant is available (or undetermined): let normal flow render ATC.
      return false;
    }
    
    // PRIORITY 2: If no pre-order, check variant existence and availability
    // Re-check isSizeSelected here in case it changed
    const isSizeSelectedNow = this.isSizeSelected ? this.isSizeSelected() : false;
    const variantExists = this.currentVariant && variantMatchesSelectedSizes;
    const variantAvailable = variantExists && this.currentVariant.available === true;
    
    // Use !hasEmptySize (real DOM) for "sizes selected" - isSizeSelected fails when currentVariant is null
    const sizesSelectedFromDOM = !hasEmptySize;
    
    // Hide pre-order button if not available
    const preOrderButton = document.querySelector(".product-form__preorder-submit");
    if (preOrderButton) {
      preOrderButton.classList.add("hidden");
    }
    
    if (sizesSelectedFromDOM && !variantExists) {
      // Variant doesn't exist: show "Unavailable"
      const addButton = document.querySelector(".product-form__submit");
      const notifyButton = document.querySelector(".klaviyo-bis-trigger");
      if (addButton) {
        this.showUnavailableButton(addButton, notifyButton);
      }
      return true; // Handled special case
    } else if (sizesSelectedFromDOM && variantExists && !variantAvailable) {
      // Variant exists but not available
      const addButton = document.querySelector(".product-form__submit");
      const notifyButton = document.querySelector(".klaviyo-bis-trigger");
      const productForm = document.querySelector(".product-form");
      const isWaitlistTemplate = productForm && productForm.classList.contains("waitlist-template");
      const waitlistAvailable = this.hasWaitlistAvailable();
      
      if (isWaitlistTemplate && waitlistAvailable) {
        // For waitlist-template with waitlist available: hide Add to Cart, show Notify Me
        if (addButton) {
          addButton.style.display = "none";
        }
        // toggleNotifyButton will handle showing the notify button
        this.toggleNotifyButton();
      } else {
        // For non-waitlist OR waitlist disabled (dwl_ tag): show "Sold Out"
        if (addButton) {
          addButton.style.display = "block";
          addButton.disabled = true;
          this.updateAddToCartButtonSoldOut(addButton);
        }
        if (notifyButton) {
          notifyButton.classList.add("hide");
        }
      }
      return true; // Handled special case
    }
    
    // If variant exists and is available, return false to continue with normal flow
    return false; // Not handled, continue with normal flow
  }

  // Check if variant has waitlist available (not disabled by dwl_ tag)
  hasWaitlistAvailable() {
    if (!this.currentVariant || !this.currentVariant.sku) {
      return false;
    }
    
    // Get product tags
    const tags = this.dataset.tags || '';
    if (!tags) {
      return true; // If no tags, assume waitlist is available
    }
    
    // Check if variant has dwl_ tag (disabled waitlist)
    // Format: dwl_ + variant.sku.replace(/[\-_]/g, '').toLowerCase()
    const variantSkuNormalized = this.currentVariant.sku.replace(/[\-_]/g, '').toLowerCase();
    const disabledWaitlistTag = `dwl_${variantSkuNormalized}`;
    
    const hasDisabledWaitlist = tags.includes(disabledWaitlistTag);
    
    // If tag exists, waitlist is disabled for this variant
    return !hasDisabledWaitlist;
  }

  // Check if pre-order is available for current selection
  hasPreOrderAvailable() {
    // Check if pre-order is enabled
    const productForm = document.querySelector(".product-form");
    const waitlistEnabled = productForm && productForm.classList.contains("waitlist-template");
    const shouldCheckPreOrder = this.enablePreOrder || waitlistEnabled;
    
    if (!shouldCheckPreOrder || !this.preOrderProduct) {
      return false;
    }

    // Check country restrictions
    const countryCode = window.theme?.country_code || this.countryCode;
    const enablePreOrderNonUSA = window.theme?.enable_pre_order_non_usa !== undefined 
      ? window.theme.enable_pre_order_non_usa 
      : this.enablePreOrderNonUSA;
    const isUSA = countryCode === 'US';
    const canShowPreOrder = isUSA || enablePreOrderNonUSA;
    
    if (!canShowPreOrder) {
      return false;
    }

    // Find matching pre-order variant
    const matchingPreOrderVariant = this.findMatchingPreOrderVariant();
    
    // Return true only if variant exists AND is available
    return matchingPreOrderVariant && matchingPreOrderVariant.available === true;
  }

  toggleShowBtn() {
    const addButton = document.querySelector(".product-form__submit");
    const notifyButton = document.querySelector(".klaviyo-bis-trigger");
    let radioGroups = document.querySelectorAll(".product-form__input:not(.jean-pack)");
    const productForm = document.querySelector("product-form.product-form");
    const Packs = document.querySelector(".pack-size__list");
    console.log(isNaN(Packs));


    if (document.querySelector("jean-pack-size")) {
      radioGroups = document.querySelectorAll(".product-form__input:not(.jean-pack)");
    }


    var showFlag = 0;

    if (isNaN(Packs) && !document.querySelector("jean-pack-size")) {
      const radioPackInputs = Packs.querySelectorAll(
        "input[type='radio']:checked"
      );
      showFlag++;
    }

    radioGroups.forEach((optionGroup) => {
      const radioInputs = optionGroup.querySelectorAll(
        "input[type='radio']:checked"
      );
      if (
        optionGroup.dataset.optionName !== "Color" && optionGroup.dataset.optionName !== "Couleur" &&
        typeof optionGroup.dataset.optionName !== "undefined" &&
        radioInputs.length > 0
      ) {
        showFlag++;
      }
    });
    
    if (showFlag == radioGroups.length - 1) {
      // addButton.style.display = 'block';
      if (document.querySelector("multi-bundle")) {
        /**
         * multibundle next btn
         */
      } else {
        // Handle Notify button visibility
        this.toggleNotifyButton();
      }
    } else {
      // addButton.style.display = 'none';
      if (document.querySelector('multi-bundle')) {
        /**
         * multibundles code
        */
        console.log('multibundles code  3f');
      } else {
        // Hide notify button when size is not selected
        notifyButton.classList.add("hide");
        notifyButton.classList.remove("enabled");
        addButton.classList.add("disable-select-size");
        addButton.style.display = 'block';
        addButton.disabled = false;
      }
      console.log("add disable b 2");
    }
    if (
      productForm &&
      productForm.classList.contains("giftcard-form") &&
      showFlag == radioGroups.length
    ) {
      addButton.classList.remove("disable-select-size");
      console.log("remove disable b 2");
    }
    if (
      productForm &&
      productForm.classList.contains("giftcard-form") &&
      showFlag == radioGroups.length
    ) {
      addButton.classList.remove("disable-select-size");
      console.log("remove disable b 2");
    }
  }

  availableSize() {
    if (document.querySelector("multi-bundle")) {
    } else {
      const addButton = document.querySelector(".product-form__submit");
      addButton.classList.remove("disable-select-size");
      console.log("remove disable b 3");
      addButton.previousElementSibling.style.display = "none";
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    
    const isSizeSelected = this.isSizeSelected ? this.isSizeSelected() : false;
    
    this.currentVariant = variantData.find((variant) => {
      const matches = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
      
      return matches;
    });
    
    // If sizes are selected, verify that the variant matches the selected sizes (excluding color)
    if (this.currentVariant && isSizeSelected) {
      const selectedOptions = this.options || [];
      const variantOptions = this.currentVariant.options || [];
      const colorIndex = this.getColorOptionIndex();
      
      const variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
        if (index === colorIndex || selectedOption === "") {
          return true; // Color or empty option, skip
        }
        return variantOptions[index] === selectedOption;
      });
      
      if (!variantMatchesSelectedSizes) {
        this.currentVariant = null;
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    // On a tee-fits-navigator landing page (window.__mbLandingPageProductSync, set by
    // sections/lp-main-product-nav.liquid), the shadowed `product` doesn't own the page's URL — don't
    // touch it at all here, same guard as replaceHistoryState() in fit-color-picker-fixed-fits.js.
    if (window.__mbLandingPageProductSync) return;
    // window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    const params = new URLSearchParams(window.location.search);
    params.set('variant', this.currentVariant.id);
    window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);

  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateFinalSaleProp(product) {
    let finalSale = false;
    if (
      product.tags &&
      product.tags.includes("mens-final-sale") ||
      product.tags &&
      product.tags.includes("womens-final-sale")
    )
      finalSale = true;
    document
      .querySelector(`#product-form-${this.dataset.section}`)
      .querySelector('input[name="properties[_final_sale]"]').value = `${finalSale ? "yes" : "no"
      }`;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        //if (source && destination) destination.innerHTML = source.innerHTML;

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");

        // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      .querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) {
        const textElement = addButton.querySelector(".addtocart-button-text");
        if (textElement) {
          textElement.textContent = text;
        } else {
          addButton.textContent = text;
        }
      }
    } else {
      addButton.removeAttribute("disabled");
      // Update button content using the new format
      this.updateAddToCartButtonContent(addButton);
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    // addButton.textContent = window.variantStrings.soldOut;
    // document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    // this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.variantData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );

    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.sectionId = this.dataset.section;

    // initialize as if variant has changed
    // this.onVariantChange();
    this.updateOptions();
   
    if (predictProduct){
      console.log('predictProduct', predictProduct);
      this.currentProduct = predictProduct;
    }

    this.firstValidation().then(() => {
      // reInitVariants() already calls onVariantChange(), so we don't need to call it here
      // Only call onVariantChange() if reInitVariants() didn't execute (no productInfo)
      if (!document.getElementById("main-product-info")) {
        this.onVariantChange();
      }
      this.disableUnavailableSwatch();
      // recognize the queryparam variant
      const params = new URLSearchParams(window.location.search);
      const variantId = params.get("variant");
      // select the variant if it exists
      if (variantId) {
        let productInfo = document.getElementById("main-product-info");
        if (productInfo) productInfo = JSON.parse(productInfo.innerHTML);
        // get the variant options from the main-product-info productInfo options array
        console.log("productInfo", productInfo);
        let variant = productInfo.variants.find((variant) => {
          return variant.id == variantId;
        });

        if (document.querySelector(".product-form__input[data-option-name='Inseam']")) {
          let option = variant.options;
          let options_names = productInfo.options_names;
          let waist = option[options_names.indexOf("Waist")];
          let inseam = option[options_names.indexOf("Inseam")];
          let waistInput = this.querySelector(
            `input[type="radio"][value="${waist}"][name="Waist"]`
          );
          let inseamInput = this.querySelector(
            `input[type="radio"][value="${inseam}"][name="Inseam"]`
          );
          if (waistInput && waistInput.disabled == false) {
            waistInput.checked = true;
          }
          if (inseamInput && inseamInput.disabled == false) {
            inseamInput.checked = true;
          }
          waistInput.dispatchEvent(new Event("change", { bubbles: true }));
          inseamInput.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          let option = variant.options;
          let options_names = productInfo.options_names;
          let size = option[options_names.indexOf("Size")];
          let sizeInput = this.querySelector(
            `input[type="radio"][value="${size}"]`
          );
          if (sizeInput) {
            sizeInput.checked = true;
          }
          sizeInput.dispatchEvent(new Event("change", { bubbles: true }));


        }
      } else {
        if (document.querySelector(".product-form__input[data-option-name='Inseam']")) {
          setTimeout(() => {
            let disabledInput = this.querySelectorAll(
              `input[type="radio"][disabled]`
            );
            if (disabledInput) {
              disabledInput.forEach((input) => {
                input.disabled = false;
              });
            }
          }, 500);
        }
      }

    });
    this.isMultibundle = document.querySelector("multi-bundle") ? true : false;
  }


  async firstValidation() {
    let productInfo = document.getElementById("main-product-info");
    if (productInfo) {
      productInfo = JSON.parse(productInfo.innerHTML);
      this.reInitVariants(productInfo);

      return;
    } else {
      return
    }
  }

  disableUnavailableSwatch() {

    const variants = this.getVariantData();

    const productForm = document.querySelector("product-form.product-form");
    if (productForm.classList.contains("waitlist-template")) {
      //return;
    }
    if (productForm.classList.contains("giftcard-form")) {
      return;
    }
    
    let tags = '';
    tags = this.dataset.tags;

    this.querySelectorAll(`input[type="radio"]`).forEach((radioItem) => {
      //radioItem.disabled = false;
    });
    if (this.options) {
      const formattedOptions = this.options.map((option, index) => {
        return {
          option: `option${index + 1}`,
          value: option,
        };
      });
 
      const varOptions = formattedOptions.filter((opt) => {
        const currentOptionFieldset = this.querySelector(
          `fieldset[data-option-index="${opt.option}"]`
        );
        if (currentOptionFieldset.dataset.optionName !== "Color" && currentOptionFieldset.dataset.optionName !== "Couleur") return opt;
      });

      console.log('tags', tags);
      //console.log('tags', tags);
      if (varOptions && varOptions.length > 1) {
        const selectedFieldSets = varOptions.filter(
          (varOption) => varOption.value != ""
        );
        if (selectedFieldSets.length) {
          selectedFieldSets.forEach((opt) => {

            const otherOptionIndex =
              ((parseInt(opt.option.replace("option", "")) - 2) ^ 1) + 2;
            const varoptFieldset = this.querySelector(
              `fieldset[data-option-index="option${otherOptionIndex}"]`
            );
            const properInputs = varoptFieldset.querySelectorAll(
              'input[type="radio"]'
            );
            const selectedVariants = variants.filter(
              (variant) => variant[opt.option] === opt.value
            );
            properInputs.forEach((inputElement) => {
              const properVariants = selectedVariants.filter(
                (variant) =>
                  variant[`option${otherOptionIndex}`] == inputElement.value
              );

              let title = '';
              if (properVariants.length) title = properVariants[0].sku?.replace(/[\-_]/g, '').toLowerCase();

              let disabledVariantTag = `dwl_${title}`;
              let tagIncludesHidedNotAvailableVariant = tags.includes('not_hide_not_existent_variants');
              let hideVariantTag = `hide_${title}`;
              let tagIncludesDisabledVariant = tags.includes(disabledVariantTag);
              let tagIncludesHideVariant = tags.includes(hideVariantTag);

              // hidden size
              inputElement.classList.remove("hidded-size");
              if (properVariants.length && tagIncludesHideVariant || !title && !tagIncludesHidedNotAvailableVariant) {
                inputElement.classList.add("hidded-size");
              } else if (inputElement.classList.contains("hidded-size")) {
                inputElement.classList.remove("hidded-size");
              }

              if (productForm.classList.contains("waitlist-template")) {
                if (properVariants.length && tagIncludesDisabledVariant && !properVariants[0].available) {
                  inputElement.disabled = !this.isVariantOrPreOrderAvailable(properVariants[0]);
                } else if (!properVariants.length) {
                  inputElement.disabled = true;
                } else {
                  inputElement.disabled = false;
                }
              } else {
                if (properVariants.length) {
                  inputElement.disabled = !this.isVariantOrPreOrderAvailable(properVariants[0]);
                } else {
                  inputElement.disabled = true;
                }
              }



            });
          });
        } else {
          // disable the ones with no inventory status

          const otherOptionIndex = 2;
          const varoptFieldset = this.querySelector(
            `fieldset[data-option-index="option${otherOptionIndex}"]`
          );
          const properInputs = varoptFieldset.querySelectorAll(
            'input[type="radio"]'
          );
          properInputs.forEach((inputElement) => {
            const properVariants = variants.filter(
              (variant) =>
                variant[`option${otherOptionIndex}`] == inputElement.value
            );

            let title = '';

            if (properVariants.length) title = properVariants[0].sku?.replace(/[\-_]/g, '').toLowerCase();

            let disabledVariantTag = `dwl_${title}`;
            console.log('disabledVariantTag', disabledVariantTag);
            let hideVariantTag = `hide_${title}`;
            let tagIncludesHidedNotAvailableVariant = tags.includes('not_hide_not_existent_variants');
            let tagIncludesDisabledVariant = tags.includes(disabledVariantTag);
            let tagIncludesHideVariant = tags.includes(hideVariantTag);

            // hidden size
            //inputElement.classList.remove("hidded-size");
            if (properVariants.length && tagIncludesHideVariant || !title && !tagIncludesHidedNotAvailableVariant) {
              //inputElement.classList.add("hidded-size");
            } else if (inputElement.classList.contains("hidded-size")) {
              //inputElement.classList.remove("hidded-size");
            }

            if (productForm.classList.contains("waitlist-template")) {
              if (properVariants.length && tagIncludesDisabledVariant && !properVariants[0].available) {
                inputElement.disabled = !this.isVariantOrPreOrderAvailable(properVariants[0]);
              } else {
                inputElement.disabled = false;
              }
            } else {
              if (properVariants.length) {
                inputElement.disabled = false;
              } else {
                inputElement.disabled = true;
              }
            }

          });
        }
      } else {
        const selectedFieldSets = varOptions.filter(
          (varOption) => varOption.value != ""
        );
        if (selectedFieldSets.length) {
          selectedFieldSets.forEach((opt) => {
            const otherOptionIndex = 2;
            const varoptFieldset = this.querySelector(
              `fieldset[data-option-index="option${otherOptionIndex}"]`
            );
            const properInputs = varoptFieldset.querySelectorAll(
              'input[type="radio"]'
            );
            const selectedVariants = variants.filter(
              (variant) => variant[opt.option] === opt.value
            );
            properInputs.forEach((inputElement) => {
              const properVariants = variants.filter(
                (variant) =>
                  variant[`option${otherOptionIndex}`] == inputElement.value
              );

              let title = '';

              if (properVariants.length) title = properVariants[0].sku?.replace(/[\-_]/g, '').toLowerCase();

              let disabledVariantTag = `dwl_${title}`;
              let hideVariantTag = `hide_${title}`;
              let tagIncludesHidedNotAvailableVariant = tags.includes('not_hide_not_existent_variants');
              let tagIncludesDisabledVariant = tags.includes(disabledVariantTag);
              let tagIncludesHideVariant = tags.includes(hideVariantTag);

              // hidden size
              inputElement.classList.remove("hidded-size");

              if (properVariants.length && tagIncludesHideVariant || !title && !tagIncludesHidedNotAvailableVariant) {
                inputElement.classList.add("hidded-size");
              } else if (inputElement.classList.contains("hidded-size")) {
                inputElement.classList.remove("hidded-size");
              }

              if (productForm.classList.contains("waitlist-template")) {
                if (properVariants.length && tagIncludesDisabledVariant && !properVariants[0].available) {
                  inputElement.disabled = !this.isVariantOrPreOrderAvailable(properVariants[0]);
                } else {
                  inputElement.disabled = false;
                }
              } else {
                if (properVariants.length) {
                  inputElement.disabled = !this.isVariantOrPreOrderAvailable(properVariants[0]);
                } else {
                  inputElement.disabled = true;
                }
              }



            });
          });
        } else {
          // disable the ones with no inventory status

          const otherOptionIndex = 2;
          const varoptFieldset = this.querySelector(
            `fieldset[data-option-index="option${otherOptionIndex}"]`
          );
          const properInputs = varoptFieldset.querySelectorAll(
            'input[type="radio"]'
          );
          properInputs.forEach((inputElement) => {
            const properVariants = variants.filter(
              (variant) =>
                variant[`option${otherOptionIndex}`] == inputElement.value
            );

            let title = '';
            if (properVariants.length) title = properVariants[0].sku?.replace(/[\-_]/g, '').toLowerCase();

            let disabledVariantTag = `dwl_${title}`;
            let hideVariantTag = `hide_${title}`;
            let tagIncludesHidedNotAvailableVariant = tags.includes('not_hide_not_existent_variants');
            let tagIncludesDisabledVariant = tags.includes(disabledVariantTag);
            let tagIncludesHideVariant = tags.includes(hideVariantTag);

            // hidden size
            inputElement.classList.remove("hidded-size");
            if (properVariants.length && tagIncludesHideVariant || !title && !tagIncludesHidedNotAvailableVariant) {
              inputElement.classList.add("hidded-size");
            } else if (inputElement.classList.contains("hidded-size")) {
              inputElement.classList.remove("hidded-size");
            }

            if (productForm.classList.contains("waitlist-template")) {
              if (properVariants.length && tagIncludesDisabledVariant && !properVariants[0].available) {
                inputElement.disabled = !this.isVariantOrPreOrderAvailable(properVariants[0]);
              } else {
                inputElement.disabled = false;
              }
            } else {
              if (properVariants.length) {
                inputElement.disabled = !this.isVariantOrPreOrderAvailable(properVariants[0]);
              } else {
                inputElement.disabled = true;
              }
            }

          });
        }
      }
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.disableUnavailableSwatch();
    this.formatOptionsData();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    
    const isSizeSelected = this.isSizeSelected ? this.isSizeSelected() : false;
    const productForm = document.querySelector("product-form.product-form");
    
    // Check if variant matches selected sizes (important when color changes)
    let variantMatchesSelectedSizes = true;
    if (this.currentVariant && isSizeSelected) {
      const selectedOptions = this.options || [];
      const variantOptions = this.currentVariant.options || [];
      const colorIndex = this.getColorOptionIndex();
      
      variantMatchesSelectedSizes = selectedOptions.every((selectedOption, index) => {
        if (index === colorIndex || selectedOption === "") {
          return true; // Color or empty option, skip
        }
        return variantOptions[index] === selectedOption;
      });
    }
    
    // If sizes are selected but variant doesn't match, treat as if variant doesn't exist
    const variantExistsAndMatches = this.currentVariant && (!isSizeSelected || variantMatchesSelectedSizes);
    
    if (variantExistsAndMatches && this.currentVariant.available) {
      this.availableSize();
      this.updateMedia();
      this.updateVariantInput();

      if (document.querySelector("multi-bundle")) {
        /**
         * multibundle next btn enable
         */
        this.enablemultibundlesNext(true, this.currentVariant);
      } else {
        this.renderProductInfo();
        this.enableSubmitBtn();
        // enableSubmitBtn already calls updateAddToCartButtonContent at the end, so no need to call it again here
        // Handle Pre-Order button visibility (check inventory for available variants)
        if (this.preOrderHandle && !this.preOrderProduct) {
          this.loadPreOrderProduct().then(() => {
            this.togglePreOrderButton();
            // Update Add to Cart button after pre-order product loads (async callback)
            const addButton = document.querySelector(".product-form__submit");
            if (addButton) {
              this.updateAddToCartButtonContent(addButton);
            }
          });
        } else {
          this.togglePreOrderButton();
        }
      }
    } else {
      // IMPORTANT: If sizes are selected but variant doesn't match, force currentVariant to null
      if (isSizeSelected && this.currentVariant && !variantMatchesSelectedSizes) {
        this.currentVariant = null;
      }
      
      // Load pre-order product if needed, then handle button state
      if (this.preOrderHandle && !this.preOrderProduct) {
        this.loadPreOrderProduct().then(() => {
          // Re-verify variant match after loading pre-order product
          const isSizeSelectedAfter = this.isSizeSelected ? this.isSizeSelected() : false;
          let variantMatchesAfter = true;
          if (this.currentVariant && isSizeSelectedAfter) {
            const selectedOptions = this.options || [];
            const variantOptions = this.currentVariant.options || [];
            const colorIndex = this.getColorOptionIndex();
            variantMatchesAfter = selectedOptions.every((selectedOption, index) => {
              if (index === colorIndex || selectedOption === "") {
                return true;
              }
              return variantOptions[index] === selectedOption;
            });
            if (!variantMatchesAfter) {
              this.currentVariant = null;
            }
          }
          this.handleVariantButtonState(isSizeSelectedAfter, variantMatchesAfter, productForm);
        });
        // Continue with current state while loading (will be updated after load)
        return;
      }
      
      // Handle button state with current data - this handles all cases (pre-order, unavailable, sold out)
      const handledSpecialCase = this.handleVariantButtonState(isSizeSelected, variantMatchesSelectedSizes, productForm);
      
      // If a special case was handled (pre-order, unavailable, sold out), we're done
      if (handledSpecialCase) {
        return;
      }
      
      // If variant exists and is available, continue with normal flow
      // But first, check if sizes are selected and variant doesn't exist (might have changed after async operations)
      const isSizeSelectedFinal = this.isSizeSelected ? this.isSizeSelected() : false;
      if (isSizeSelectedFinal && !this.currentVariant) {
        const addButton = document.querySelector(".product-form__submit");
        const notifyButton = document.querySelector(".klaviyo-bis-trigger");
        if (addButton) {
          this.showUnavailableButton(addButton, notifyButton);
        }
        return;
      }
      
      // For waitlist-template, use disableSubmitBtn which handles notify button logic
      if (productForm.classList.contains("waitlist-template")) {
        this.disableSubmitBtn();
      } else {
        // For non-waitlist templates, just enable the submit button
        this.enableSubmitBtn();
      }
    }

    if (document.querySelector("multi-bundle")) { } else {
      this.updateURL();
      this.toggleShowBtn();
    }

    //console.log("toggleShowBtn 2");
  }

  // renderSizeGuideBtn(){
  //   const hasSizeGuide = document.querySelector('#size-chart-modal-bg');
  //   if(!hasSizeGuide) return;

  //   const button = document.createElement('button');
  //   button.textContent = 'Size Guide';
  //   button.classList.add('pdp_size-guide');
  //   button.addEventListener('click', () => {
  //     document.querySelector('#size-chart-modal-bg').classList.toggle('open');
  //   });
  //   this.appendChild(button);
  // } 

  enablemultibundlesNext(enable = true, variant) {
    if (this.multiBundle) {
      this.multiBundle.nextButtonsSelectors.forEach(btn => {

        if (enable) {
          btn.dataset.disabled = "false";
          //btn.disabled = false;
          this.multiBundle.handlePriceSum(variant);
          btn.dataset.selectedVariant = JSON.stringify(variant);
        } else {
          btn.dataset.disabled = "true";
          //btn.disabled = true;
        }
      })
    }
  }

  getColorOptionIndex() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const colorIndex = fieldsets.findIndex(fieldset => {
      const optionName = fieldset.dataset.optionName;
      return optionName === "Color" || optionName === "Couleur";
    });
    return colorIndex !== -1 ? colorIndex : 0; // Default to 0 if not found
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => {
          return radio.checked;
        }
      );
      return checkedRadio ? checkedRadio.value : "";
    });
  }

  formatOptionsData() {
    if (this.options) {
      const formattedOptions = this.options.map((option, index) => {
        return {
          option: `option${index + 1}`,
          value: option,
        };
      });

      this.resetVariantBtns();
      this.filterOutUnavailableVariants(formattedOptions);
    }
  }

  resetVariantBtns() {
    this.querySelectorAll("fieldset input[type='radio']").forEach((radio) => {
      radio.classList.add("disabled");
    });
  }

  filterOutUnavailableVariants(options) {
    const variants = this.getVariantData();

    const varOptions = options.filter((opt) => {
      const currentOptionFieldset = this.querySelector(
        `fieldset[data-option-index="${opt.option}"]`
      );
      if (currentOptionFieldset.dataset.optionName !== "Color" && currentOptionFieldset.dataset.optionName !== "Couleur") return opt;
    });

    if (varOptions && varOptions.length > 1) {
      this.filterOnMultipleOptions(varOptions, variants);
    } else {
      this.filterOnSingleOption(varOptions, variants);
    }
  }

  filterOnSingleOption(options, variants) {
    options.forEach((opt) => {
      const availVarsWithCurrentOption = variants
        .filter((variant) => this.isVariantOrPreOrderAvailable(variant))
        .map((filteredvariant) => {
          return {
            ...filteredvariant,
            options_object: filteredvariant.options.map((varoption, i) => {
              return { option: `option${i + 1}`, value: varoption };
            }),
          };
        });
      availVarsWithCurrentOption.forEach((variant) => {
        variant.options_object.forEach((varopt) => {
          if (varopt.option !== opt.option) return;
          else {
            const varoptFieldset = this.querySelector(
              `fieldset[data-option-index="${varopt.option}"]`
            );
            varoptFieldset.dataset.optionName === "Color" || varoptFieldset.dataset.optionName === "Couleur"
              ? ""
              : varoptFieldset
                .querySelector(`input[value="${varopt.value}"]`)
                .classList.remove("disabled");
          }
        });
      });
    });
  }

  filterOnMultipleOptions(options, variants) {
    options.forEach((opt) => {
      const availVarsWithCurrentOption = variants
        .filter(
          (variant) =>
            (variant[opt.option] === opt.value || opt.value === "") &&
            this.isVariantOrPreOrderAvailable(variant)
        )
        .map((filteredvariant) => {
          return {
            ...filteredvariant,
            options_object: filteredvariant.options.map((varoption, i) => {
              return { option: `option${i + 1}`, value: varoption };
            }),
          };
        });
      availVarsWithCurrentOption.forEach((variant) => {
        variant.options_object.forEach((varopt) => {
          if (varopt.option === opt.option) return;
          else {
            const varoptFieldset = this.querySelector(
              `fieldset[data-option-index="${varopt.option}"]`
            );
            varoptFieldset.dataset.optionName === "Color" || varoptFieldset.dataset.optionName === "Couleur"
              ? ""
              : varoptFieldset
                .querySelector(`input[value="${varopt.value}"]`)
                .classList.remove("disabled");
          }
        });
      });
    });
  }

  reInitVariants(product) {
    var options = product.options;
   
    const variants = product.variants;
    if (options.length > 0 && options[0].name === "Color" && options[0].values.length > 1) {
      options[0].values = [options[0].values[0]];
    }
    fetch(`${Shopify.routes.root}products/${product.handle}?view=metafields`)
      .then((response) => response.json())
      .then((metadata) => {
        this.currentProduct = product;
        const radioGroups = document.querySelectorAll(".product-form__input:not(.jean-pack)");
        var currentRadioStatus = [];
        radioGroups.forEach((optionGroup) => {
          const radioInputs = optionGroup.querySelectorAll(
            "input[type='radio']:checked"
          );
          if (optionGroup.dataset.optionName != "Color" && optionGroup.dataset.optionName != "Couleur") {
            if (radioInputs.length > 0) {
              currentRadioStatus.push({
                option_name: optionGroup.dataset.optionName,
                option_value: radioInputs[0].value,
              });
            } else {
              currentRadioStatus.push({
                option_name: optionGroup.dataset.optionName,
                option_value: "",
              });
            }
          }
        });

        this.resetForm();

        /**
         * Multibundle toEdit
         */
        if (this.toEdit) currentRadioStatus = this.toEdit;

        this.resetFieldSets(options, variants, metadata, currentRadioStatus);
        // manually trigger onchange event - this will handle all button state logic
        this.onVariantChange();

        if (document.querySelector("multi-bundle")) {
          console.log('multi bundle line 1380');
        } else {
          this.updateFinalSaleProp(product);
        }

        // render the sizeguide button
        // this.renderSizeGuideBtn();

        this.updateWairPlacement(product);

        if (this.currentVariant && this.currentVariant.available) {
          //alert("available");
          console.log({
            product, variant: this.currentVariant
          });

          //console.log('next selectors: ',this.multiBundle.nextButtonsSelectors);
          this.enablemultibundlesNext(true, this.currentVariant);

          if (document.querySelector('multi-bundle')) {
            /**
             * variant radios code
             */
            console.log('variant radios code 2f');
          } else {
            this.enableSubmitBtn();
          }
        } else {
          if (document.querySelector('multi-bundle')) {
            /**
             * variant radios code
             */
            console.log('variant radios code 55f');
          } else {
            // onVariantChange() already handles all button state logic, no need to duplicate here
          }
          //alert("not available");
          this.enablemultibundlesNext(false);
        }


        this.toggleShowBtn();
        console.log("toggleShowBtn 3");
      });

    // this.resetFieldSets(options, variants);
    
  }

  resetForm() {
    this.innerHTML = "";
  }

  formatWairProductKey(productHandle) {
    if (
      productHandle &&
      (productHandle.startsWith("bdl6-mubb") ||
        productHandle.startsWith("bdl3-mubb"))
    ) {
      return "mubb-sssm-blac";
    } else if (
      productHandle &&
      (productHandle.startsWith("bdl6-mutr") ||
        productHandle.startsWith("bdl3-mutr"))
    ) {
      return "mutr-sssm-blac";
    } else {
      return productHandle;
    }
  }

  updateWairPlacement(product) {
    const wairPlacementEls = document.querySelectorAll(".predict-placement");

    wairPlacementEls.forEach((el) => {
      el.dataset.predictProductKey = this.formatWairProductKey(product.handle);
      el.dataset.predictProductName = product.title;
      el.dataset.predictProductImg = product.featured_image;
    });
  }

  resetFieldSets(options, variants, metadata = "", currentRadioStatus = []) {

    console.log('currentRadioStatus    : ', currentRadioStatus);
    
    const fieldSets = options.map((option, optionIndex) => {
      const option_title = option.name.toLowerCase();
      const option_name = window.theme[`${option.name}`] ? window.theme[`${option.name}`] : option.name;
      const option_selected =
        option.name === "Color" || option.name === "Couleur"
          ? {}
          : currentRadioStatus.find(
            ({ option_name }) => option_name === option.name
          );
      return `
        <fieldset count="${option.values.length}" class="js product-form__input ${option.name.toLowerCase()}_convert" data-option-name="${option.name
        }" data-option-index="option${optionIndex + 1}">
          <legend class="form__label">${optionIndex < 2 ? option_name : window.theme.inseam_text
        }: <br><span class="option-meta-data">${metadata[option_title] ? metadata[option_title] : ""
        }</span></legend>
          ${option.values
          .map((value, index) => {
            console.log(option_selected);
            return `
              <input type="radio" id="${this.sectionId}-${option.name}-${index}"
                     name="${option.name}"
                     value="${value.trim()}"
                     form="product-form-${this.sectionId}"
                     ${option.name === "Color" || option.name === "Couleur"
                ? "checked"
                : option_selected &&
                  option_selected.option_value === value
                  ? "checked"
                  : ""
              }
              >
              <label for="${this.sectionId}-${option.name}-${index}">
                ${value}
              </label>
            `;
          })
          .join("")}
        </fieldset>
      `;
    });
    const variantJson = `
      <script type="application/json" id="variant-status">
        ${JSON.stringify(variants)}
      </script>
    `;
    this.innerHTML = fieldSets.join("") + variantJson;
  }
}

customElements.define("variant-radios", VariantRadios);

// Global function to update Pre-Order when product changes (can be called from fit-color-picker)
window.updatePreOrderOnProductChange = async function(productHandle, productTags) {
  const variantRadios = document.querySelector('variant-radios');
  if (variantRadios && variantRadios.updatePreOrderForNewProduct) {
    await variantRadios.updatePreOrderForNewProduct(productHandle, productTags);
    // The button will be updated in updatePreOrderForNewProduct and also in reInitVariants
  }
};

// AfterSell PDP Upsells hook: when defined, AfterSell adds the item via /cart/add.js
// and calls this instead of hijacking the product form, which our custom PDPs don't support.
window.pdpUpsellHandleCartDrawer = async function () {
  const sideCart = document.querySelector("side-cart");
  if (!sideCart) return;
  await sideCart.getCart();
  sideCart.openCart();
};


document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    if (document.querySelector(".klaviyo-bis-trigger")) {
      document.querySelector(".klaviyo-bis-trigger").classList.remove("loading");
      document.querySelector(".klaviyo-bis-trigger").classList.remove("disabled");
    }
    
  }, 500);

});


/* Extra Intelligems mercer test code for plp */




var igLoaded = false;
window.addEventListener("message", (event) => {
  if (event.data === "ig-ready") {
    igLoaded = true;
    setTimeout(() => {
      if (document.querySelectorAll('product-card')) {
          document.querySelectorAll('product-card').forEach((card) => {
              if (!card.querySelector('.card-information__text')) return;
              let title = card.querySelector('.card-information__text').innerText;
             
              // if contanis Mercer and pack
              if (title.includes('MERCER') && title.includes('PACK')) {
                  
                  
                  let totalPrice = card.querySelector('.price-item.product-card.price-item--sale ').innerText; // example Straight Mercer Jeans 3-Pack
      
                  let packSize = title.split('Pack')[0].split(' ')[title.split('Pack')[0].split(' ').length - 1]; // this return something like 3-PACK , 
                  packSize = packSize.split('-')[0]; // this return 3
                  
                  // format usd to onlyu ammount $
                  let price = totalPrice.split('$')[1];
                  // price as number
                  price = parseFloat(price);
      
                  let badge = card.querySelector('.product_badge');
                  if (parseFloat(price) && packSize && badge && Shopify.currency.active == "USD") {
                      
                      let pricePerItem = price / packSize;
                      let pricePerItemText = `$${pricePerItem.toFixed(2)} EACH`;
                      badge.innerText = pricePerItemText;
                      
                  } else {
                      //debugger;
                  }
                  
      
              }
          });
      }
    }
    , 500);
   
    
  }
}); 




/**
 * FTC CODE
 * FTC: First time customer
 * ismbc : is mott and bow customer
 * epcall: endpoint call 
 */

function evaluateFirstTimeCustomerByUi() {
  let foundReceipt = false;

  try {
      let data = JSON.parse(localStorage.getItem("__ui"));

      if (!Array.isArray(data)) {
          return false;
      }

      foundReceipt = data.some(subArray => {
          if (!Array.isArray(subArray)) {
              return false;
          }
          return subArray.some(item => {
              if (item.receipt && item.receipt.status === "processed") {
                  return true;
              }
              return false;
          });
      });
  } catch (error) {
      console.error("Error evaluating first-time customer:", error);
  }

  return foundReceipt;
}
function readDasVariable() {
  // Read the 'mprtcl-v4_50F4D000' local storage
  const mprtc = localStorage.getItem('mprtcl-v4_50F4D000');
  console.log(mprtc);

  if (!mprtc) return false;

  try {
    // Replace '|' with ',' to make the string valid JSON
    const validJsonString = mprtc.replace(/\|/g, ',').replace(/'/g, '"');
    const parsedData = JSON.parse(validJsonString);
    const das = parsedData.gs && parsedData.gs.das;
    if (das) return das;
  } catch (error) {
    console.error("Error reading das variable:", error);
    console.error("Invalid JSON:", mprtc);
  }

  return false;
}

function evaluateFirstTimeCustomerByEndpoint() {
  return new Promise((resolve, reject) => {
    let payload = {
      "api_key": "Ok&zOB@0B3%$L9JI"
    };

   
    const das = readDasVariable();

    const email = takeEmailFromLocalStorage();
      
  
    

    email? payload["email"] = email : null;
    das? payload["das"] = das : null;  
    

    fetch("https://us-central1-mb-data-lake.cloudfunctions.net/customer_data_ftc_public", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data);


        if (data && Object.values(data).some(value => value === true)) {
          resolve(data);
        } else {
          resolve(false);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        reject(error);
      });
  });
}

function takeEmailFromLocalStorage() {
  let email = null;

  const emaim_from___em = localStorage.getItem('__em');
  const __ui = JSON.parse(localStorage.getItem("__ui"));
  const email_from_wo = localStorage.getItem('wo_email');
  const emaim_from_klaviyo = localStorage.getItem('klaviyo_email');
  

  if (emaim_from___em) {
    return emaim_from___em;
  }

  __ui? email = __ui.reduce((email, subArray) => {
    if (email) return email;
    if (!Array.isArray(subArray)) return null;

    const itemWithEmail = subArray.find(item => item.receipt);
    return itemWithEmail ? itemWithEmail.receipt.purchaseOrder.email : null;
  }, null) : null;
  

  if (!email && email_from_wo) email = email_from_wo;
  if (!email && emaim_from_klaviyo) email = emaim_from_klaviyo; 

  email? localStorage.setItem("__em", email) : null;

  return email || null;
}

/**
 * evaluate if the local storage variable ismbc exist
 * if not evaluate if the __ui local storage variable exist and return true if the user is a first time customer
 * if not evaluate the endpoint and return true if the user is a mott and bow customer
 */



async function evalFTC(forceEpcall = false) {
  let ismbc = localStorage.getItem("ismbc");
  let epcall = JSON.parse(localStorage.getItem("epcall"));

  /**
   * como ismbc se esta definiendo = 1 en el evento de checkout_completed
   * si un usuario ya compro, no pasa por aca 
   * va directo al else y se termina la funcion
   */
  if (!ismbc || ismbc != 1 || forceEpcall) {
      // if epcall does not exist OR epcall value is false and epcall date is more than 86400000 (1 day) or forceEpcall is true
      if ( !epcall || (!epcall?.value && (new Date() - new Date(epcall?.date)) > 86400000) || forceEpcall) { 
            evaluateFirstTimeCustomerByEndpoint()
            .then(existEP => {
              const epCallValue = existEP && Object.values(existEP).some(value => value === true) === true ? true : false;
              const ismbcValue = epCallValue ? 1 : 0;
              
                localStorage.setItem("ismbc", ismbcValue); 
                localStorage.setItem("epcall", JSON.stringify({
                  "date": new Date(),
                  "value": epCallValue
                }));
                return ismbcValue;
            })
            .catch(error => {
              console.error('Error evaluating first-time customer by endpoint:', error);
                return 0;
            });
      } else if (epcall.value) { // if epcall value is true
        return 1;
      } else {
        return 0;
      }
  } else  {
    return ismbc;
  }
  
}
evalFTC().then((x) => {
  localStorage.setItem("ismbc", x);
  // Debug mode for ismbc
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('debugmbc') === 'true') {
    if (x == 0) {
      alert("current session not customer");
    } else {
      alert("current session is a customer");
    }
  }
});

function evalFTCElemets(force_notfct = false) {
  let ismbc = localStorage.getItem("ismbc");
  const subHeroText = document.querySelector('.set-text-plp'); 

  if (ismbc && ismbc == 1 || force_notfct) {
    const notFtcElements = document.querySelectorAll('.not-ftc');
    notFtcElements.forEach(element => {
      element.classList.remove('hidden');
    });

    if (subHeroText) {
      subHeroText.classList.remove('hidden');
    }

  } else {
    const ftcElements = document.querySelectorAll('.ftc');
    ftcElements.forEach(element => {
      element.classList.remove('hidden');
    });

    if (subHeroText) {
      subHeroText.innerText = 'Shop our premium essentials as sets. Free shipping options available!';
      subHeroText.classList.remove('hidden');
    }
  }
}

/**
 * END OF FTC CODE
 */

/**
 * Gets DOM elements related to compact price and VIP price
 * @returns {Object} Object containing all relevant DOM elements
 */
/**
 * Returns the active M&B Club VIP discount percent, or 0 when the customer is not a VIP.
 * The .price__vip container is only rendered server-side for members
 * (customer.tags contains 'Rivo Membership Tier: Membership'), so its presence is the
 * signal that the customer is VIP. The discount lives in its data-discount-percent attribute.
 * @returns {number} VIP discount percent (0 when not a member)
 */
function getMbClubVipDiscountPercent() {
  const vipContainer = document.querySelector(".price__vip--unit") || document.querySelector(".price__vip--pack");
  if (!vipContainer) return 0;
  const attr = vipContainer.getAttribute("data-discount-percent");
  return parseFloat(attr) || parseFloat(window.theme?.mb_club_discount_percent) || 0;
}

/**
 * Pre-order button copy test (Intelligems).
 * The active version comes from ?po_btn= (QA override) or window.theme.po_button_version
 * (set by the Intelligems per-group custom JS); anything else renders the control.
 * Design doc: docs/superpowers/specs/2026-07-07-preorder-button-ig-test-design.md
 */
function getPreorderButtonVersion() {
  const versions = ['control', 'v1', 'v2', 'v3', 'v4'];
  try {
    // The QA override persists in sessionStorage because the color pickers rewrite the
    // URL with history.replaceState and drop the query params (?po_btn= would be lost
    // on the first color change). ?po_btn=reset clears it.
    const urlVersion = new URLSearchParams(window.location.search).get('po_btn');
    if (urlVersion === 'reset') {
      sessionStorage.removeItem('po_btn');
    } else if (urlVersion && versions.includes(urlVersion)) {
      sessionStorage.setItem('po_btn', urlVersion);
      return urlVersion;
    }
    const stored = sessionStorage.getItem('po_btn');
    if (stored && versions.includes(stored)) return stored;
  } catch (e) {
    // ignore (sessionStorage unavailable)
  }
  const version = window.theme?.po_button_version;
  return versions.includes(version) ? version : 'control';
}

/**
 * The add-to-cart button paired with a pre-order button. v3 (pre-order primary) and v4
 * (equal-weight tabs) present both CTAs as one block, so they need to reach the ATC too —
 * control/v1/v2 never touch it.
 * Singles: <button class="product-form__submit"> — tag-qualified because .klaviyo-bis-trigger
 * carries the same class. Packs: <span class="multiple-add-to-cart">.
 */
function getPreorderPairedAtcButton(button) {
  const scope =
    button.closest('.product-form__buttons') ||
    button.closest('product-pack') ||
    button.closest('form') ||
    document;
  return scope.querySelector('button.product-form__submit, .multiple-add-to-cart');
}

/**
 * v3/v4 lay the two CTAs out as one unit, which the theme markup does not: on singles they
 * sit in .product-form__buttons with the notify link between them, on packs they are loose
 * siblings among the error/note spans. Wrapping both at runtime gives those versions one
 * predictable box to style and keeps Liquid rendering the control markup.
 *
 * Both buttons also get a role class (.po-layout__atc / .po-layout__pre) so the CSS can name
 * them once instead of repeating the single and pack class for every rule — it has to key off
 * the pre-order button's visibility via :has(), which doubles every selector otherwise.
 *
 * Idempotent, and restores the original DOM when the version switches away from v3/v4.
 */
function syncPreorderLayoutWrapper(preorderButton, atcButton, version) {
  const active = version === 'v3' || version === 'v4';
  const existing = preorderButton.closest('.po-layout');

  if (!active) {
    if (!existing) return;
    // Restore back-to-front: each node's original next sibling is the node after it in the
    // list, so the later ones have to be back in place first for insertBefore to find them.
    [preorderButton, atcButton, existing.__poAtcPrev].forEach((el) => {
      if (!el) return;
      el.classList.remove('po-layout__atc', 'po-layout__pre');
      if (!el.__poOrigParent) return;
      const anchor = el.__poOrigNext && el.__poOrigParent.contains(el.__poOrigNext) ? el.__poOrigNext : null;
      el.__poOrigParent.insertBefore(el, anchor);
      delete el.__poOrigParent;
      delete el.__poOrigNext;
    });
    // Never drop the wrapper while it still holds anything: the bookkeeping above lives in JS
    // properties, so a wrapper that outlived them (a re-render, a hand-made one) would take the
    // add-to-cart button out of the page with it. Splice any leftovers back where it sits.
    while (existing.firstChild) existing.parentNode.insertBefore(existing.firstChild, existing);
    existing.remove();
    return;
  }

  if (!atcButton || !atcButton.parentNode) return;
  atcButton.classList.add('po-layout__atc');
  preorderButton.classList.add('po-layout__pre');
  if (existing) {
    existing.className = `po-layout po-layout--${version}`;
    return;
  }
  // The theme treats whatever sits immediately before the ATC as its error span and reaches
  // for it unguarded — availableSize() does `addButton.previousElementSibling.style.display`
  // (global.js), and product-form.js does the same to show the message. Leaving it behind
  // makes those throw on the next variant change, which aborts onVariantChange before it
  // restores the button label or re-shows the pre-order button (the ATC then sticks on
  // "Unavailable"/"Sold Out"). So it travels into the wrapper, still directly before the ATC.
  const atcPrev = atcButton.previousElementSibling;

  // Capture the original slots before moving anything, so switching version mid-session
  // (QA ?po_btn=, or Intelligems resolving late) restores the DOM exactly.
  [atcPrev, atcButton, preorderButton].forEach((el) => {
    if (!el) return;
    el.__poOrigParent = el.parentNode;
    el.__poOrigNext = el.nextSibling;
  });
  const wrapper = document.createElement('div');
  wrapper.className = `po-layout po-layout--${version}`;
  wrapper.__poAtcPrev = atcPrev;
  atcButton.parentNode.insertBefore(wrapper, atcPrev || atcButton);
  if (atcPrev) wrapper.appendChild(atcPrev);
  wrapper.appendChild(atcButton);
  wrapper.appendChild(preorderButton);
}

/**
 * Renders the pre-order button content (top line + date line) for the active test version.
 * Shared by singles (updatePreOrderButtonContent) and packs (pack-bundle-fixed-fits.js).
 * @param {HTMLElement} button
 * @param {Object} data
 * @param {number} data.price - effective price in dollars (VIP price for members)
 * @param {number|null} data.compareAt - compare-at price in dollars (original price for VIP)
 * @param {string|null} data.shipDate - short formatted ship date, e.g. "Aug 3"
 * @param {number|null} [data.displayCompareAt] - overrides the compare-at behind the saving
 *   shown by v1/v3/v4 (and v1's struck-through price). Packs pass the original ready-to-ship
 *   pack's final price so the saving reflects retail − pre-order; singles omit it (fall back
 *   to compareAt). Display-only — the cart discount is unaffected.
 */
function renderPreorderButtonContent(button, data) {
  if (!button || !data) return;
  const textEl = button.querySelector('.preorder-button-text');
  const priceEl = button.querySelector('.pack-preorder-price, .preorder-button-price');
  const compareEl = button.querySelector('.pack-preorder-compare-price, .preorder-button-compare-price');
  const dateEl = button.querySelector('.pack-preorder-date, .preorder-button-date');
  const savingsEl = button.querySelector('.preorder-button-savings');
  const ctaEl = button.querySelector('.preorder-button-cta');

  const currencySymbol = window.theme?.cart_currency_symbol || '$';
  const shopCurrency = window.theme?.shop_currency || '';
  const formatMoney = typeof Shopify !== 'undefined' && Shopify.formatMoneyAmmount ? Shopify.formatMoneyAmmount : (n) => Number(n).toFixed(2);
  const money = (amount) => `${currencySymbol}${formatMoney(amount)} ${shopCurrency}`.trim();

  const version = getPreorderButtonVersion();
  const hasCompare = data.compareAt != null && data.compareAt > data.price;
  const priceText = money(data.price);
  const compareText = hasCompare ? money(data.compareAt) : '';

  // The saving behind v1's "SAVE $X" and v3/v4's percentage. Packs pass displayCompareAt (the
  // original ready-to-ship pack's final price, e.g. 114.72) so the saving reflects
  // retail − pre-order instead of the pre-order pack's own compare-at (Nx pre-order unit =
  // 95.97); singles fall back to compareAt (retail unit price). Display-only.
  const displayCompare = (data.displayCompareAt != null && data.displayCompareAt > data.price)
    ? data.displayCompareAt
    : (hasCompare ? data.compareAt : null);
  const savingsAmount = displayCompare != null ? Math.round(displayCompare - data.price) : 0;
  const savingsPercent = displayCompare != null
    ? Math.round(((displayCompare - data.price) / displayCompare) * 100)
    : 0;

  // Cache so the po-button-version listener can re-render when Intelligems loads late.
  button.__poRenderData = data;
  button.setAttribute('data-po-version', version);
  // Canonical ship date for the cart line message (product-form.js) — the visible
  // date-line copy varies per version, so the cart must not parse it from the DOM text.
  if (data.shipDate) {
    button.setAttribute('data-preorder-ship-date', data.shipDate);
  } else {
    button.removeAttribute('data-preorder-ship-date');
  }

  const setCompare = (html) => {
    if (!compareEl) return;
    compareEl.innerHTML = html;
    compareEl.style.display = html ? 'inline' : 'none';
  };
  const setSlot = (el, text) => {
    if (!el) return;
    el.textContent = text || '';
    el.style.display = text ? '' : 'none';
  };

  // v3/v4 restyle the paired ATC into the same block (demoted link / second tab).
  syncPreorderLayoutWrapper(button, getPreorderPairedAtcButton(button), version);

  // Slots owned by v3/v4 only. Cleared up front so every other version renders the control
  // markup — the spans collapse to nothing when empty.
  setSlot(savingsEl, '');
  setSlot(ctaEl, '');

  if (version === 'v1') {
    // SAVE $13 · ADD PRE-ORDER $44.99 $31.99 (uppercased by CSS)
    // Show the compare-at (struck-through) next to the price so the saving is visible —
    // "SAVE $X" is exactly displayCompare − price.
    if (textEl) textEl.textContent = savingsAmount > 0 ? `Save ${currencySymbol}${savingsAmount} · Add Pre-Order` : 'Add Pre-Order';
    setCompare(displayCompare != null ? `<s>${money(displayCompare)}</s>` : '');
    if (priceEl) priceEl.textContent = priceText;
    if (dateEl) dateEl.textContent = data.shipDate ? `Est. Ships ${data.shipDate}` : '';
  } else if (version === 'v2') {
    // LOCK IN YOUR PRE-ORDER PRICE $31.99 / EST. SHIP AUG 3 · PRE-ORDER PRICE ENDS AFTER SHIPMENT DATE
    if (textEl) textEl.textContent = 'Lock In Your Pre-Order Price';
    setCompare('');
    if (priceEl) priceEl.textContent = priceText;
    if (dateEl) {
      const parts = [];
      if (data.shipDate) parts.push(`Est. Ship ${data.shipDate}`);
      if (hasCompare) parts.push('Pre-Order Price Ends After Shipment Date');
      dateEl.textContent = parts.join(' · ');
    }
  } else if (version === 'v3') {
    // Pre-order primary: PRE-ORDER NOW — $31.99 (SAVE 29%) / EST. SHIP AUG 3, with the ATC
    // demoted to a text link underneath. The ATC copy ("Or …at", "Ready to Ship") is done in
    // CSS: the theme rewrites .addtocart-button-text on every variant change (Add to Cart /
    // Sold Out / Unavailable), so copy injected into it here would not survive.
    if (textEl) textEl.textContent = 'Pre-Order Now —';
    setCompare('');
    if (priceEl) priceEl.textContent = priceText;
    setSlot(savingsEl, savingsPercent > 0 ? `(Save ${savingsPercent}%)` : '');
    if (dateEl) dateEl.textContent = data.shipDate ? `Est. Ship ${data.shipDate}` : '';
  } else if (version === 'v4') {
    // Equal-weight tabs: READY TO SHIP $44.99 [Add to Cart] | PRE-ORDER $31.99 [Add to Cart]
    // EST. SHIP AUG 3, with a "29% OFF" badge. The ready-to-ship tab is the ATC button itself
    // restyled — its text/price/status spans already hold everything that tab shows.
    if (textEl) textEl.textContent = 'Pre-Order';
    setCompare('');
    if (priceEl) priceEl.textContent = priceText;
    setSlot(savingsEl, savingsPercent > 0 ? `${savingsPercent}% Off` : '');
    setSlot(ctaEl, 'Add to Cart');
    if (dateEl) dateEl.textContent = data.shipDate ? `Est. Ship ${data.shipDate}` : '';
  } else {
    // Control: current design
    if (textEl) textEl.textContent = 'Add Pre-Order';
    setCompare(hasCompare ? `<s>${compareText}</s>` : '');
    if (priceEl) priceEl.textContent = priceText;
    if (dateEl) dateEl.textContent = data.shipDate ? `Wait & Save: Estimated to Ship ${data.shipDate}` : '';
  }
}

window.theme = window.theme || {};
window.theme.renderPreorderButtonContent = renderPreorderButtonContent;

// Intelligems per-group custom JS dispatches this event after setting
// window.theme.po_button_version, so buttons already painted pick up the version.
document.addEventListener('po-button-version', () => {
  document.querySelectorAll('.product-form__preorder-submit, .multiple-add-to-cart-preorder').forEach((button) => {
    if (button.__poRenderData) renderPreorderButtonContent(button, button.__poRenderData);
  });
});

function getPriceElements() {
  return {
    compactUnit: document.querySelector(".product-compact-price__unit"),
    compactPack: document.querySelector(".product-compact-price__pack"),
    compactRegValueUnit: document.querySelector(".product-compact-price__unit .product-compact-price__reg-value"),
    compactCompareUnit: document.querySelector(".product-compact-price__unit .product-compact-price__compare"),
    vipUnit: document.querySelector(".price__vip--unit"),
    vipPack: document.querySelector(".price__vip--pack"),
    unitPrice: document.querySelector(".unit__price"),
    titlePrice: document.querySelector(".pack-title__price")?.closest("dl")
  };
}

/**
 * Updates both compact price snippet and VIP price when variant, fit, color or pack changes
 * Handles all VIP-related logic including visibility of price elements
 * @param {HTMLElement} packSize - Pack size input element (optional, will be found if not provided)
 * @param {number} packPrice - Pack price in dollars (optional, calculated if not provided)
 * @param {number} ogPrice - Original price in dollars without discount (optional)
 * @param {number} priceInCents - Price in cents for VIP calculation (optional, will be calculated if not provided)
 * @param {HTMLElement} priceItem - Price item element (optional, used as fallback for pack price)
 * @param {number} compareAtPriceInCents - Compare at price in cents for unit (optional)
 * @param {string} productId - Product ID for data attributes (optional)
 */
function updatePriceSnippets(packSize = null, packPrice = null, ogPrice = null, priceInCents = null, priceItem = null, compareAtPriceInCents = null, productId = null) {
  // Get packSize if not provided
  if (!packSize) {
    packSize = document.querySelector(".pack-size__wrapper input:checked") || document.querySelector(".pack-size__list input:checked");
  }
  
  // Si no hay selector de pack (p. ej. PDP sin product-pack o solo unidad), tratar como unit para actualizar VIP/compact
  const isUnit = !packSize ? true : packSize.value == 1;
  const elements = getPriceElements();
  
  if (!packSize && (!priceInCents || priceInCents <= 0)) return;
  if (packSize && !packSize.value) return;
  
  // ===== COMPACT PRICE SNIPPET =====
  if (isUnit) {
    // Unit: show unit container, hide pack container
    if (elements.compactUnit) elements.compactUnit.classList.remove("hidden");
    if (elements.compactPack) elements.compactPack.classList.add("hidden");
    
    // Update unit compact price values if priceInCents is provided
    if (priceInCents && priceInCents > 0 && elements.compactRegValueUnit) {
      elements.compactRegValueUnit.textContent = `: ${window.theme.cart_currency_symbol} ` + Shopify.formatMoneyAmmount(priceInCents / 100);
      if (productId) {
        elements.compactRegValueUnit.setAttribute("data-product-id", productId);
      }
    }
    
    if (elements.compactCompareUnit) {
      if (compareAtPriceInCents && compareAtPriceInCents > 0) {
        elements.compactCompareUnit.innerHTML = `| <span style="text-decoration: line-through;">${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(compareAtPriceInCents / 100)}</span>`;
        elements.compactCompareUnit.style.display = "inline";
      } else {
        elements.compactCompareUnit.style.display = "none";
      }
      if (productId) {
        elements.compactCompareUnit.setAttribute("data-product-id", productId);
      }
    }
  } else {
    // Pack: hide unit container, show pack container
    if (elements.compactUnit) elements.compactUnit.classList.add("hidden");
    if (elements.compactPack) elements.compactPack.classList.remove("hidden");
    
    // Update pack compact price values
    const compactRegValue = elements.compactPack ? elements.compactPack.querySelector(".product-compact-price__reg-value") : null;
    const compactCompare = elements.compactPack ? elements.compactPack.querySelector(".product-compact-price__compare") : null;

    const activeColor = document.querySelector(".color-set__wrapper input:checked");
    const dummyPrice = activeColor ? Number(activeColor.getAttribute("dummy-price")) : null;
    const dummyCompare = activeColor ? Number(activeColor.getAttribute("dummy-compared-price")) : null;
    const activeProductId = activeColor ? activeColor.getAttribute("grand-parent-id") : null;

    if (compactRegValue) {
      if (packPrice) {
        compactRegValue.textContent = `: ${window.theme.cart_currency_symbol} ` + Shopify.formatMoneyAmmount(packPrice);
      } else if (dummyPrice) {
        compactRegValue.textContent = `: ${window.theme.cart_currency_symbol} ` + Shopify.formatMoneyAmmount(dummyPrice / 100);
      } else {
        const unitSale = document.querySelector(".price-item.price-item--sale");
        const unitRegular = document.querySelector(".price-item.price-item--regular");
        const unitSaleText = unitSale ? unitSale.textContent.replace(/\s+/g, " ").trim() : "";
        const unitRegularText = unitRegular ? unitRegular.textContent.replace(/\s+/g, " ").trim() : "";
        compactRegValue.textContent = `: ${unitSaleText || unitRegularText}`;
      }
      if (activeProductId) {
        compactRegValue.setAttribute("data-product-id", activeProductId);
      }
    }
    if (compactCompare) {
      // Check if there's already a span inside for the price
      let priceSpan = compactCompare.querySelector("span");
      if (!priceSpan) {
        priceSpan = document.createElement("span");
        priceSpan.style.textDecoration = "line-through";
        compactCompare.appendChild(priceSpan);
      }
      
      if (ogPrice) {
        compactCompare.innerHTML = `| <span style="text-decoration: line-through;">${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(ogPrice)}</span>`;
        compactCompare.style.display = "inline";
      } else if (dummyCompare && dummyCompare > (dummyPrice || 0)) {
        compactCompare.innerHTML = `| <span style="text-decoration: line-through;">${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(dummyCompare / 100)}</span>`;
        compactCompare.style.display = "inline";
      } else {
        const unitOld = document.querySelector(".price-item.old-price");
        const unitSale = document.querySelector(".price-item.price-item--sale");
        const unitOldText = unitOld ? unitOld.textContent.replace(/\s+/g, " ").trim() : "";
        const unitSaleText = unitSale ? unitSale.textContent.replace(/\s+/g, " ").trim() : "";
        if (unitOldText && unitOldText !== unitSaleText) {
          // Extract just the price part (remove "|" if present)
          const priceOnly = unitOldText.replace(/^\|\s*/, '');
          compactCompare.innerHTML = `| <span style="text-decoration: line-through;">${priceOnly}</span>`;
          compactCompare.style.display = "inline";
        } else {
          compactCompare.style.display = "none";
        }
      }
      if (activeProductId) {
        compactCompare.setAttribute("data-product-id", activeProductId);
      }
    }
  }
  
  // ===== VIP PRICE =====
  // Show/hide VIP containers based on pack size
  if (isUnit) {
    if (elements.vipUnit) elements.vipUnit.classList.remove("hidden");
    if (elements.vipPack) elements.vipPack.classList.add("hidden");
  } else {
    if (elements.vipUnit) elements.vipUnit.classList.add("hidden");
    if (elements.vipPack) elements.vipPack.classList.remove("hidden");
  }
  
  // Get the appropriate VIP container
  const vipContainer = isUnit ? elements.vipUnit : elements.vipPack;
  const vipPriceElement = vipContainer ? vipContainer.querySelector(".price__vip-value") : null;
  
  // Only update VIP if element exists and user is a member
  if (vipPriceElement && vipContainer) {
    const parseMoneyTextToCents = (text) => {
      if (!text) return null;
      const cleaned = text.replace(/\s+/g, " ").trim();
      const priceMatch = cleaned.match(/[\d,]+\.?\d*/);
      if (!priceMatch) return null;
      const priceValue = parseFloat(priceMatch[0].replace(/,/g, ""));
      return priceValue > 0 ? Math.round(priceValue * 100) : null;
    };

    // For packs, mirror compact price logic to get base price
    let vipPriceInCents = priceInCents;
    if (!isUnit) {
      const activeColor = document.querySelector(".color-set__wrapper input:checked");
      const dummyPrice = activeColor ? Number(activeColor.getAttribute("dummy-price")) : null;
      const unitSale = document.querySelector(".price-item.price-item--sale");
      const unitRegular = document.querySelector(".price-item.price-item--regular");
      const unitSaleText = unitSale ? unitSale.textContent : "";
      const unitRegularText = unitRegular ? unitRegular.textContent : "";

      if (packPrice && packPrice > 0) {
        vipPriceInCents = Math.round(packPrice * 100);
      } else if (dummyPrice) {
        vipPriceInCents = Math.round(dummyPrice);
      } else {
        const textPriceCents = parseMoneyTextToCents(unitSaleText || unitRegularText);
        if (textPriceCents) {
          vipPriceInCents = textPriceCents;
        }
      }

      // If still no price, try to get from priceItem text
      if ((!vipPriceInCents || vipPriceInCents === 0) && priceItem) {
        const priceText = priceItem.textContent || priceItem.innerText;
        const textPriceCents = parseMoneyTextToCents(priceText);
        if (textPriceCents) {
          vipPriceInCents = textPriceCents;
        }
      }
    }
    
    // Get VIP discount from data attribute or window.theme
    let discountPercent = 0;
    const discountAttr = vipContainer.getAttribute("data-discount-percent");
    if (discountAttr && discountAttr !== '') {
      discountPercent = parseFloat(discountAttr) || 0;
    } else if (window.theme?.mb_club_discount_percent) {
      discountPercent = parseFloat(window.theme.mb_club_discount_percent) || 0;
    }
    
    if (vipPriceInCents && vipPriceInCents > 0) {
      const discountAmount = discountPercent > 0 ? (vipPriceInCents * discountPercent) / 100 : 0;
      const vipPrice = vipPriceInCents - discountAmount;
      
      // Convert to dollars and round up to 2 decimal places
      const vipPriceInDollars = vipPrice / 100;
      // Round up to 2 decimal places: multiply by 100, ceil, then divide by 100
      const vipPriceRounded = Math.ceil(vipPriceInDollars * 100) / 100;
      const vipMoneyPrice = Shopify.formatMoneyAmmount(vipPriceRounded);
      
      // Always show price with currency symbol (match theme.cart_currency_symbol used elsewhere)
      const currencySymbol = (typeof window.theme !== 'undefined' && window.theme.cart_currency_symbol) ? window.theme.cart_currency_symbol : '$';
      const finalVipPriceText = `${currencySymbol}${vipMoneyPrice}`;
      vipPriceElement.textContent = finalVipPriceText;
    }
  }
  
  // ===== VIP PRICE VISIBILITY LOGIC =====
  // Handle visibility of unitPrice and titlePrice based on VIP price and pack size
  if (!isUnit) {
    const hasVipPrice = elements.unitPrice && elements.unitPrice.classList.contains("price--vip");
    
    if (hasVipPrice) {
      // If VIP price exists, keep unitPrice visible but hide pack-title__price
      if (elements.unitPrice) elements.unitPrice.classList.remove("hidden");
      if (elements.titlePrice) elements.titlePrice.classList.add("hidden");
    } else {
      // If no VIP price, show pack-title__price and hide unitPrice
      if (elements.unitPrice) elements.unitPrice.classList.add("hidden");
      if (elements.titlePrice) elements.titlePrice.classList.remove("hidden");
    }
  } else {
    // For unit, show unitPrice and hide titlePrice
    if (elements.unitPrice) elements.unitPrice.classList.remove("hidden");
    if (elements.titlePrice) elements.titlePrice.classList.add("hidden");
  }
}

/**
 * Legacy function - Updates compact price snippet (calls updatePriceSnippets)
 * @param {HTMLElement} packSize - Pack size input element
 * @param {number} packPrice - Pack price in dollars
 * @param {number} ogPrice - Original price in dollars
 */
function updateCompactPriceSnippet(packSize, packPrice, ogPrice) {
  if (typeof updatePriceSnippets === 'function') {
    const priceInCents = packSize.value == 1 ? null : (packPrice && packPrice > 0 ? Math.round(packPrice * 100) : null);
    const priceItem = packSize.nextElementSibling ? packSize.nextElementSibling.querySelector(".price") : null;
    updatePriceSnippets(packSize, packPrice, ogPrice, priceInCents, priceItem);
  }
}

/**
 * Legacy function - Updates VIP price (calls updatePriceSnippets)
 * @param {number} priceInCents - Price in cents
 * @param {string} type - 'unit' or 'pack'
 * @param {HTMLElement} packSize - Pack size input element
 * @param {HTMLElement} priceItem - Price item element
 */
function updateVipPrice(priceInCents, type = 'unit', packSize = null, priceItem = null) {
  if (typeof updatePriceSnippets === 'function') {
    if (!packSize) {
      packSize = document.querySelector(".pack-size__wrapper input:checked");
    }
    if (packSize) {
      const packPrice = type === 'pack' && priceInCents ? priceInCents / 100 : null;
      updatePriceSnippets(packSize, packPrice, null, priceInCents, priceItem);
    }
  }
}

/**
 * Captures the li_did tracking param from the URL and stores it as a cart
 * attribute (note_attributes) via /cart/update.js so it's attached to the order.
 */
(function captureLiDidCartAttribute() {
  const liDid = new URLSearchParams(window.location.search).get('li_did');
  if (!liDid) return;

  if (sessionStorage.getItem('li_did_synced') === liDid) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        li_did: liDid
      }
    })
  })
    .then((response) => response.json())
    .then(() => {
      sessionStorage.setItem('li_did_synced', liDid);
    })
    .catch((error) => {
      console.error('Error syncing li_did cart attribute:', error);
    });
})();